webpackJsonp([6],{

/***/ 134:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getCurrentLang = __webpack_require__(135);

Object.defineProperty(exports, 'getCurrentLang', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getCurrentLang).default;
  }
});

var _setContent = __webpack_require__(354);

Object.defineProperty(exports, 'setContent', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_setContent).default;
  }
});

var _prepareIncomingData = __webpack_require__(355);

Object.defineProperty(exports, 'prepareIncomingData', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_prepareIncomingData).default;
  }
});

var _getResponsiveParams = __webpack_require__(356);

Object.defineProperty(exports, 'getResponsiveParams', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getResponsiveParams).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getCurrentLang;
/**
 * Возвращает текущий язык сайта
 * @returns {string}
 */
function getCurrentLang() {
  return document.documentElement.lang.split('-').pop().toLocaleLowerCase();
}

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Внутрення, горизотальная прокрутка элементов со стилизацией
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
  value: true
});

__webpack_require__(67);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Внутренний namespace
 * @const {string}
 * @private
 * @sourceCode
 */
var ns = 'horizontal-scroll';

/**
 * Список собранных элементов, к кототорым применен скролл
 * @type {Array|JQuery}
 * @private
 * @sourceCode
 */
var $list = [];

/**
 * Обработчик собития `scroll.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @private
 * @sourceCode
 */
function onScroll(event) {
  var $holder = $(this);
  var _event$data = event.data,
      gap = _event$data.gap,
      $wrapper = _event$data.$wrapper,
      $element = _event$data.$element;


  var holderWidth = $holder.innerWidth();
  var holderScroll = $holder.scrollLeft();
  var holderScrollOffset = holderScroll + holderWidth + gap;
  var tableWidth = $element[0].scrollWidth;

  var doClassLeft = 'removeClass';
  var doClassRight = 'removeClass';

  if (holderScroll > gap) {
    doClassLeft = 'addClass';
  }

  if (tableWidth > holderScrollOffset) {
    doClassRight = 'addClass';
  }

  $wrapper[doClassLeft](ns + '--left');
  $wrapper[doClassRight](ns + '--right');

  if ($holder.data(ns + '-synchronized') !== true) {
    /**
     * @param {JQuery} $syncHolder
     */
    var eachHolder = function eachHolder($syncHolder) {
      $syncHolder.data(ns + '-synchronized', true);
      $syncHolder.scrollLeft(holderScroll);
    };
    $element.data(ns + '-$holders').forEach(eachHolder);
  }
  $holder.data(ns + '-synchronized', false);
}

/**
 * Обработчик собития `destroy.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @private
 * @sourceCode
 */
function onDestroy(event) {
  var _$this$off$unwrap$unw;

  var $holder = event.data.$holder;

  var $this = $(this);
  var index = $list.index($holder);
  if (~index) {
    $list.splice(index, 1);
    if ($list.length === 0) {
      $(window).off('resize.' + ns, onResize);
    }
  }
  $this.off('destroy.' + ns, onDestroy).unwrap().unwrap().removeClass(ns + '__element').removeInitedKey(ns).data((_$this$off$unwrap$unw = {}, _defineProperty(_$this$off$unwrap$unw, ns + '-$holder', null), _defineProperty(_$this$off$unwrap$unw, ns + '-$holders', null), _$this$off$unwrap$unw));
}

/**
 * Обработчик собития `mousedown.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @private
 * @sourceCode
 */
function onDown(event) {
  var _event$data2 = event.data,
      $holder = _event$data2.$holder,
      $wrapper = _event$data2.$wrapper;

  $wrapper.addClass(ns + '--mousedown');
  $holder.on('mousemove.' + ns, { $holder: $holder, $wrapper: $wrapper, downX: event.pageX }, onMove);
}

/**
 * Обработчик собития `mouseup.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @private
 * @sourceCode
 */
function onUp(event) {
  var _event$data3 = event.data,
      $holder = _event$data3.$holder,
      $wrapper = _event$data3.$wrapper;

  $wrapper.removeClass(ns + '--mousedown');
  $holder.off('mousemove.' + ns, onMove);
}

/**
 * Обработчик собития `mousemove.${ns}`
 * @param {Event} event
 * @param {Object} event.data
 * @param {jQuery} event.data.$holder
 * @param {jQuery} event.data.$wrapper
 * @private
 * @sourceCode
 */
function onMove(event) {
  var gutter = 12;
  var _event$data4 = event.data,
      downX = _event$data4.downX,
      $holder = _event$data4.$holder,
      $wrapper = _event$data4.$wrapper;
  var x = event.pageX,
      y = event.pageY;


  var offset = $wrapper.offset();
  var left = offset.left + gutter;
  var top = offset.top + gutter;
  var right = left - gutter * 2 + $wrapper.innerWidth();
  var bottom = top - gutter * 2 + $wrapper.innerHeight();

  if (x < left || x > right || y < top || y > bottom) {
    $holder.trigger('mouseup.' + ns);
    return false;
  }
  var scroll = $holder.scrollLeft() - (x - downX) / 2;
  $holder.scrollLeft(scroll);
}

/**
 * Обработчик собития `destroy.${ns}` для `window`
 * @private
 * @sourceCode
 */
function onResize() {
  if ($list.length) {
    $list.trigger('scroll');
  }
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Оборачивание элементов и добавление прослушки на горизотальную прокрутку.
 * При инициализации каждому элементу добавляеться запись `data('horizontal-scroll', true)`
 * Для того чтобы отфильтровывать уже инициализированные элементы при возможных последующих обращениях
 *
 * Каждому элементу добавляеться CSS класс, а также оборачивается нужной разметкой
 * для стилизации и возможность устастановки прослушек.
 *
 * Пример начальной разметки
 *
 * ```markup
 * <div class="wysiwyg">
 *     <table>
 *         <!-- content -->
 *     </table>
 * </div>
 * ```
 *
 * Пример результата
 *
 * ```markup
 * <div class="wysiwyg">
 *     <div class="horizontal-scroll"> <!-- Стилизация псевдоэлементами слева и справа в зависимости от прокрутки -->
 *         <div class="horizontal-scroll__holder"> <!-- Создает прокрутку и не нем же весят события скрола -->
 *             <table class="horizontal-scroll__element">
 *                 <!-- content -->
 *             </table>
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Инит таблиц</caption>
 * horizontalScroll('.wysiwyg table');
 *
 * @example <caption>Инит таблиц в текущем контейнере</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Инит таблиц в текущем контейнере с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', $currentContainer, 20);
 *
 * @example <caption>Инит таблиц с зазором в 20 пикселей</caption>
 * horizontalScroll('.wysiwyg table', null, 20);
 *
 * @param {JQuery.Selector|JQuery} selector - поиск элементов по селектору или jQuery element
 * @param {JQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @param {number} [gap=4] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @sourceCode
 */
function horizontalScroll(selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var gap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 4;

  /**
   * @type {JQuery}
   */
  var $elements = selector && selector.jquery ? selector : $(selector, $context);

  $elements.each(function (i, el) {
    var $element = $(el);

    if ($element.hasInitedKey(ns, false)) {
      return true;
    }

    $element.addClass(ns + '__element').wrap('<div class="' + ns + '"><div class="' + ns + '__holder"></div></div>');
    horizontalScroll.init($element, gap);
  });
}

/**
 * Инициализация прослушки
 * Метод можно использовать отдельно, если у вас уже есть готовая структура разметки
 *
 * Необходимая структура
 *
 * ```markup
 * <div class="horizontal-scroll">
 *     <div class="horizontal-scroll__holder">
 *         <div class="horizontal-scroll__element">
 *             <!-- content -->
 *         </div>
 *     </div>
 * </div>
 * ```
 *
 * @example <caption>Необходимая структура</caption>
 * let $element = $('.horizontal-scroll__element);
 * horizontalScroll.init($element);
 * // horizontalScroll.init($element, 20); // => с зазором в 20 пикселей
 *
 * @param {JQuery} $element - поиск элементов по селектору
 * @param {number} [gap=3] - зазор для скролла (в пикселях), который определяет, когда добавлять/удалять классы стилизации
 * @method horizontalScroll::init
 * @inner
 */
horizontalScroll.init = function ($element) {
  var gap = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;

  if ($element.hasInitedKey(ns)) {
    return true;
  }

  var $holder = $element.parent();
  var $wrapper = $holder.parent();

  $holder.on('scroll.' + ns, { gap: gap, $element: $element, $wrapper: $wrapper }, onScroll);
  $holder.on('mousedown.' + ns, { $holder: $holder, $wrapper: $wrapper }, onDown);
  $holder.on('mouseup.' + ns, { $holder: $holder, $wrapper: $wrapper }, onUp);
  $holder.on('dragstart.' + ns, function () {
    return false;
  });
  $element.on('destroy.' + ns, { $holder: $holder }, onDestroy);
  $element.data(ns + '-$holder', $holder);
  $element.data(ns + '-$holders', []);

  if ($list.length) {
    $list = $list.add($holder);
  } else {
    $list = $holder;
    $(window).on('resize.' + ns, onResize);
  }

  $holder.trigger('scroll.' + ns);
};

/**
 * Синхронизация скролов
 * __Важно!__ метод нужно вызывать после инициализации скролов для каждлго из элементов
 *
 * @example
 * let $elements = $('.elements');
 * horizontalScroll($elements);
 * horizontalScroll.sync($elements);
 *
 * @param {JQuery} $elements
 * @method horizontalScroll::sync
 * @inner
 * @sourceCode
 */
horizontalScroll.sync = function ($elements) {
  $elements.each(function (i, el) {
    var $el = $(el);
    var $holders = [];

    $elements.not($el).each(function (i, el) {
      $holders.push($(el).data(ns + '-$holder'));
    });

    $el.data(ns + '-$holders', $holders);
  });
};

/**
 * Удаление внутреннего скролла
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table');
 *
 * @example <caption>Удаление внутреннего скрола с таблиц в текущем контейнере</caption>
 * horizontalScroll.destroy('.wysiwyg table', $currentContainer);
 *
 * @example <caption>Удаление внутреннего скрола с нужного элемента</caption>
 * horizontalScroll.destroy($myElement);
 *
 * @param {JQuery.Selector|JQuery} selector - Селектор или jQuery элемент
 * @param {JQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @method horizontalScroll::destroy
 * @inner
 */
horizontalScroll.destroy = function (selector) {
  var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (selector && selector.jquery) {
    selector.trigger('destroy.' + ns);
    return;
  }

  $(selector, $context).each(function (i, el) {
    var $element = $(el);
    $element.trigger('destroy.' + ns);
  });
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = horizontalScroll;

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит валидации форм
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(67);

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {JQuery.Selector|JQuery} [selector=".js-form"]- поиск элементов по селектору
 * @param {JQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function validate() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-form';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	/**
  * @type {JQuery}
  */
	var $forms = selector && selector.jquery ? selector : $(selector, $context);
	$forms.each(function (i, el) {
		var $form = $(el);
		if ($form.hasInitedKey('validator', false)) {
			return true;
		}

		var preloader = new _Preloader2.default($form);
		preloader.show();

		__webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 406)).then(function (config) {
			var configDefault = config.default;

			var _require = __webpack_require__(360),
			    setHandlers = _require.default;

			var _require2 = __webpack_require__(361),
			    phoneMask = _require2.default;

			var configUser = $form.data('validation-config') || {};
			var configCurrent = $.extend(true, {}, configDefault, configUser);

			phoneMask($form);
			$form.validate(configCurrent);
			setHandlers($form, $form.data('validator'));
			preloader.hide();
		});
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = validate;

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Оборачивание элементов для пропорцинальной адаптации
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(67);

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {JQuery.Selector|JQuery} [selector=".js-form"]- поиск элементов по селектору
 * @param {JQuery} [$context=null] - контекст в котором будет выполнен поиск селектора
 * @sourceCode
 */
function wrapMedia(selector) {
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

	/**
  * @type {JQuery}
  */
	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $el = $(el);
		if ($el.hasInitedKey('wrap-media', false)) {
			return true;
		}

		var width = parseInt($el.attr('width') || $el[0].offsetWidth);
		var height = parseInt($el.attr('height') || $el[0].offsetHeight);
		var ratio = parseFloat((height / width * 100).toFixed(2));

		$el.unwrap('p').wrap('\n\t\t<div class="ratio-wrapper" style="max-width:' + width + 'px;margin-left:auto;margin-right:auto;">\n\t\t\t<div class="ratio" style="padding-top:' + ratio + '%;"></div>\n\t\t</div>\n\t\t');
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wrapMedia;

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип image, с галереей
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#image-type}
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#gallery}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {JQuery.Selector} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	$context.each(function (i, el) {
		var $element = $(el);
		var delegateTarget = $element.data('delegate');
		if (delegateTarget) {
			selector = delegateTarget;
		}
		var config = $.extend(true, {
			type: 'image',
			delegate: selector,
			gallery: {
				enabled: true,
				preload: [0, 2],
				navigateByImgClick: true,
				arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>'
			},
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			callbacks: {
				elementParse: function elementParse(item) {
					if ($(item.el).hasClass('js-gallery-video')) {
						item.type = 'iframe';
						item.iframe = {
							patterns: {
								youtube: {
									index: 'youtube.com/',
									id: 'v=',
									src: '//www.youtube.com/embed/%id%?autoplay=1'
								},
								vimeo: {
									index: 'vimeo.com/',
									id: '/',
									src: '//player.vimeo.com/video/%id%?autoplay=1'
								},
								gmaps: {
									index: '//maps.google.',
									src: '%id%&output=embed'
								}
							}
						};
					} else {
						item.type = 'image';
						item.tLoading = 'Loading image #%curr%...';
						item.mainClass = 'mfp-img-mobile';
					}
				}
			}
		}, userConfig);

		$element.magnificPopup(config);

		$(document).on('galleryClose', function () {
			if ($element.is($.magnificPopup.instance.ev[0])) {
				$($.magnificPopup.instance.wrap).trigger('click');
				$element.on('mfpClose', function () {
					$(document).trigger('galleryClosed');
				});
			} else {
				$(document).trigger('galleryClosed');
			}
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {JQuery.Selector} [selector="[data-mfp-src]"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('.js-mfp-gallery')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpGallery() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '[data-mfp-src]';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('.js-mfp-gallery');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	/**
  * @param {JQuery.Event} event
  */
	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 69)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.trigger(event.type);
		});
	}

	$context.on('click', selector, load);
}

$('.js-delegate-link').on('click', function () {
	$($(this).data('delegate-target')).first().trigger('click');
});

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpGallery;

/***/ }),

/***/ 143:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.videoPreview = videoPreview;
function videoPreview($elements) {
	$elements.each(function (i, el) {
		var $el = $(el);
		var $image = $el.find('[data-preview-image]');
		var $video = $el.find('[data-video]');
		var $playButton = $el.find('[data-play-button]');

		$playButton.on('click', function () {
			$(this).addClass('is-hidden');
			$image.addClass('is-hidden');
			$video.attr('src', $video.attr('src') + '?autoplay=1');
		});
	});
}

/***/ }),

/***/ 145:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(146);

__webpack_require__(348);

__webpack_require__(352);

var _defaultConfig = __webpack_require__(353);

var _defaultConfig2 = _interopRequireDefault(_defaultConfig);

__webpack_require__(97);

var _horizontalScroll = __webpack_require__(136);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _validate = __webpack_require__(137);

var _validate2 = _interopRequireDefault(_validate);

var _wrapMedia = __webpack_require__(138);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _mfpAjax = __webpack_require__(363);

var _mfpAjax2 = _interopRequireDefault(_mfpAjax);

var _mfpInline = __webpack_require__(364);

var _mfpInline2 = _interopRequireDefault(_mfpInline);

var _mfpIframe = __webpack_require__(365);

var _mfpIframe2 = _interopRequireDefault(_mfpIframe);

var _mfpGallery = __webpack_require__(139);

var _mfpGallery2 = _interopRequireDefault(_mfpGallery);

var _wstabs = __webpack_require__(366);

var _wstabs2 = _interopRequireDefault(_wstabs);

var _cookieData = __webpack_require__(96);

var _cookieData2 = _interopRequireDefault(_cookieData);

var _Notifier = __webpack_require__(368);

var _Notifier2 = _interopRequireDefault(_Notifier);

var _slider = __webpack_require__(98);

var _slider2 = _interopRequireDefault(_slider);

var _toggle = __webpack_require__(371);

var _toggle2 = _interopRequireDefault(_toggle);

var _switchText = __webpack_require__(372);

var _switchText2 = _interopRequireDefault(_switchText);

var _selectBox = __webpack_require__(373);

var _selectBox2 = _interopRequireDefault(_selectBox);

var _scrollToElement = __webpack_require__(382);

var _scrollToElement2 = _interopRequireDefault(_scrollToElement);

var _close = __webpack_require__(383);

var _close2 = _interopRequireDefault(_close);

var _siteSearch = __webpack_require__(384);

var _siteSearch2 = _interopRequireDefault(_siteSearch);

var _scrollUp = __webpack_require__(386);

var _scrollUp2 = _interopRequireDefault(_scrollUp);

var _accordion = __webpack_require__(387);

var _accordion2 = _interopRequireDefault(_accordion);

var _favorites = __webpack_require__(99);

var _favorites2 = _interopRequireDefault(_favorites);

var _setCurrency = __webpack_require__(390);

var _setCurrency2 = _interopRequireDefault(_setCurrency);

var _filter = __webpack_require__(391);

var _filter2 = _interopRequireDefault(_filter);

var _getCurrentLang = __webpack_require__(135);

var _getCurrentLang2 = _interopRequireDefault(_getCurrentLang);

var _openPopup = __webpack_require__(393);

var _showMore = __webpack_require__(394);

var _multiSelect = __webpack_require__(395);

var _layoutFilter = __webpack_require__(397);

var _currencyChanger = __webpack_require__(399);

var _popupSliderClose = __webpack_require__(400);

var _iframeLazyload = __webpack_require__(401);

var _videoPreview = __webpack_require__(143);

var _controlPanel = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Public
// ----------------------------------------

// Устраняет ошибку в IE11 => https://github.com/gdi2290/NG6-starter/issues/114

/**
 * @fileOverview Основной файл инициализации модулей
 */

// ----------------------------------------
// Imports
// ----------------------------------------

window.Noty = _Notifier2.default;

/**
 * Переопределяем обработчик window.onerror для отлова ошибок, которые выпали в глобальную облать
 * Бывает полезно, когда валятся скрипты только на мобильных и нет возможности заглянуть в консоль
 */

// import prism from './_modules/prismjs/prism';
var oldOnerror = window.onerror;
window.onerror = function (message, url, lineNumber) {
	// let msg = `Ошибка: ${message}\n\nSource => ${url}\nLine => ${lineNumber}`;
	if (oldOnerror) {
		oldOnerror.apply(this, arguments);
	}
	// alert(msg);
	document.body.classList.add('script-error');
	document.body.classList.remove('is-loading');
	document.body.style = 'opacity: 1 !important';
};

window.jQuery(document).ready(function ($) {
	window.projectConfig = $.extend(true, {}, _defaultConfig2.default, window.initConfig || {});
	var $body = $('body');
	var $jsInits = $('.js-init');

	Array.prototype.forEach.call(document.forms, function (form) {
		form.autocomplete = 'off';
	});

	// prism();
	(0, _horizontalScroll2.default)('.wysiwyg table');
	(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video');
	(0, _validate2.default)('.js-form');
	(0, _mfpAjax2.default)();
	(0, _mfpInline2.default)();
	(0, _mfpIframe2.default)();
	(0, _mfpGallery2.default)();
	(0, _popupSliderClose.popupSliderClose)();
	_wstabs2.default.init();
	_wstabs2.default.setActive(); // если нужно принудительно активировать табы
	_cookieData2.default.askUsage(); // если нужно использовать куки

	var $sliders = $jsInits.filter('[data-slider]');
	if ($sliders.length) {
		(0, _slider2.default)($sliders.toArray());
	}

	var $togglers = $jsInits.filter('[data-toggle]');
	if ($togglers.length) {
		(0, _toggle2.default)($togglers);
	}

	var $switchTextNodes = $jsInits.filter('[data-switch-text]');
	if ($switchTextNodes.length) {
		(0, _switchText2.default)($switchTextNodes);
	}

	var $selectBoxes = $jsInits.filter('[data-select-box]');
	if ($selectBoxes.length) {
		(0, _selectBox2.default)($selectBoxes);
	}

	function importMap($maps) {
		__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 407)).then(function (_ref) {
			var initMaps = _ref.initMaps;

			initMaps($maps);
		});
	}

	var $maps = $jsInits.filter('[data-map]');
	if ($maps.length) {
		if ($maps.data('map') === 'init-click') {
			$maps.on('click', function () {
				importMap($maps);
				$maps.find('.map-wait').fadeOut(300);
			});
		} else {
			importMap($maps);
		}
	}

	var $scrollTriggers = $jsInits.filter('[data-scroll-to-element]');
	if ($scrollTriggers.length) {
		$scrollTriggers.on('click.scroll', '[data-scroll-to]', function (e) {
			var $this = $(e.currentTarget);
			(0, _scrollToElement2.default)($this.data('scroll-to'));
		});
	}

	var $videoPreviews = $jsInits.filter('[data-video-preview]');
	if ($videoPreviews.length) {
		(0, _videoPreview.videoPreview)($videoPreviews);
	}

	var $closeElems = $jsInits.filter('[data-close]');
	if ($closeElems.length) {
		(0, _close2.default)($closeElems);
	}

	var $siteSearchElems = $jsInits.filter('[data-live-search="site-search"]');
	if ($siteSearchElems.length) {
		(0, _siteSearch2.default)($siteSearchElems);
	}

	var $upScrollers = $jsInits.filter('[data-scroll-up]');
	if ($upScrollers.length) {
		(0, _scrollUp2.default)($upScrollers);
	}

	var $scrollers = $('[data-scroller]');
	if ($scrollers.length) {
		/**
   * Не инициализируем в IE и Edge по той причине, что вылазит странная ошибка
   * `SCRIPT70: Permission denied`
   * В будущем надо разобраться, что это за ошибка и почему вылазит.
   * Быстрый поиск показал, что чаще всего эта ошибка возникает, когда iframe пытается выполнить JS.
   * Но данный плагин не использует iframe-ы.
   */
		if (!window.Modernizr.mobiledevice && !window.Modernizr.cssscrollbar && !window.Modernizr.ie && !window.Modernizr.edge) {
			__webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 408)).then(function (_ref2) {
				var scrollBar = _ref2.scrollBar;

				scrollBar($scrollers);
			});
		}
	}

	var $accordions = $jsInits.filter('[data-accordion]');
	if ($accordions.length) {
		(0, _accordion2.default)($accordions);
	}

	var $favoriteTriggers = $jsInits.filter('[data-favorites]');
	if ($favoriteTriggers.length) {
		(0, _favorites2.default)($favoriteTriggers);
	}

	var $multiSelects = $jsInits.filter('[data-multiselect]');
	if ($multiSelects.length) {
		(0, _multiSelect.initMultiSelect)($multiSelects);
	}

	var $rangeSliders = $jsInits.filter('[data-range-slider]');
	if ($rangeSliders.length) {
		__webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 409)).then(function (_ref3) {
			var initRangeSlider = _ref3.initRangeSlider;

			initRangeSlider($rangeSliders);
		});
	}

	var $layoutFilters = $jsInits.filter('[data-layout-filter]');
	if ($layoutFilters.length) {
		(0, _layoutFilter.initLayoutFilter)($layoutFilters);
	}

	var $currencySetters = $jsInits.filter('[data-currency-setter]');
	if ($currencySetters.length) {
		(0, _setCurrency2.default)($currencySetters);
	}

	var $filters = $jsInits.filter('[data-filter]');
	if ($filters.length) {
		(0, _filter2.default)($filters);
	}

	var $currencyChangers = $jsInits.filter('[data-currency-changer]');
	if ($currencyChangers.length) {
		(0, _currencyChanger.currencyChanger)($currencyChangers);
	}

	var $frames = $jsInits.filter('[data-iframe-lazyload]');
	if ($frames.length) {
		(0, _iframeLazyload.iframeLazyload)($frames);
	}

	var $controlPanels = $jsInits.filter('[data-control-panel-trigger]');
	if ($controlPanels.length) {
		(0, _controlPanel.controlPanel)($controlPanels);
	}

	$(window).on('scroll', function () {
		var _window = window,
		    scrollY = _window.scrollY;


		$body.toggleClass('page-is-on-top', scrollY < 150);
	}).trigger('scroll');

	$(window).on('resize', function () {}).trigger('resize');

	$body.removeClass('is-loading').addClass('is-ready');

	$('.js-phone-show').one('click', function (evt) {
		evt.preventDefault();
		$(this).find('.js-phone-text').removeAttr('style');
		$(this).find('.js-phone-ga').remove();
	});

	var $showMore = $jsInits.filter('[data-show-more]');

	if ($showMore.length) {
		(0, _showMore.initShowMore)($showMore);
	}
});

window.onload = function () {
	(0, _openPopup.openPopup)();
};

document.oncopy = function () {
	var bodyElement = document.body;
	var selection = getSelection();
	var href = document.location.href;
	var copyright = void 0;
	if ((0, _getCurrentLang2.default)() === 'ru') {
		copyright = "<br><br>Источник: <a href='" + href + "'>" + href + '</a><br>';
	} else if ((0, _getCurrentLang2.default)() === 'ua') {
		copyright = "<br><br>Джерело: <a href='" + href + "'>" + href + '</a><br>';
	}
	var text = selection + copyright;
	var divElement = document.createElement('div');
	divElement.style.position = 'absolute';
	divElement.style.left = '-99999px';
	divElement.innerHTML = selection;
	if (divElement.innerHTML.length > 50) {
		divElement.innerHTML = text;
	}
	bodyElement.appendChild(divElement);
	selection.selectAllChildren(divElement);
	setTimeout(function () {
		bodyElement.removeChild(divElement);
	}, 0);
};

if (true) {
	__webpack_require__(404);
}

/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _utils = __webpack_require__(134);

exports.default = {
	debug: false,
	route: {
		media: '/Media',
		ajax: {}
	},
	plugin: {
		slider: {
			preset: {
				building_card: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: false,
					multipleDrag: true,
					threshold: 30,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {},
					onChange: function onChange() {
						this.updateActive();
					}
				},
				checked_builders: {
					duration: 200,
					easing: 'ease-out',
					perPage: (0, _utils.getResponsiveParams)(400, 3),
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: true, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: true, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {},
					onChange: function onChange() {
						this.updateActive();
					}
				},
				building_view_gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: (0, _utils.getResponsiveParams)(180, 8),
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: false,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {},
					onChange: function onChange() {
						this.updateActive();
					}
				},
				building_view_mobile_gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {},
					onChange: function onChange() {
						this.updateActive();
					}
				},
				building_progress: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {},
					onChange: function onChange() {
						this.updateActive();
					}
				},
				gallery: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onInit: function onInit() {
						this.printSlideIndexWithIndicator();
					},
					onChange: function onChange() {
						this.updateActive();
						this.printSlideIndexWithIndicator();
					}
				},
				banner_reviews: {
					duration: 200,
					easing: 'ease-out',
					perPage: 1,
					startIndex: 0,
					draggable: true,
					multipleDrag: true,
					threshold: 20,
					keyboardNav: true,
					dots: false, // custom option
					arrows: true, // custom option
					arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
					loop: true,
					rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT CORRECT LOGIC]
					autoplay: false, // custom option
					autoplayInterval: 3000, // custom option
					stopOnHover: true, // custom option
					rtl: false,
					onChange: function onChange() {
						this.updateActive();
					}
				}
			}
		},
		gmap: {
			common: {
				mapStyle: []
			}
		},
		toggle: {
			preset: {
				dropdown: {
					map: {
						'.dropdown': 'is-open',
						'body': 'dropdown-is-open'
					},
					stops: ['.dropdown__body']
				},
				selectBox: {
					map: {
						'.select-box': 'is-open',
						'body': 'select-box-is-open'
					},
					stops: ['.select-box__content']
				},
				shareDropdown: {
					map: {
						'.share-dropdown': 'is-open',
						'body': 'share-dropdown-is-open'
					},
					stops: ['.share-dropdown__body']
				}
			}
		}
	}
};

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = setContent;
/**
 * Реплейсит ключи в шаблонное строке по заданому объекту с данными, где ключ в строке совпадают с ключами в объекте
 * @param tpl
 * @param oKeys
 * @returns {*}
 */
function setContent(tpl, oKeys) {
	var buffer = tpl;

	Object.keys(oKeys).forEach(function (key) {
		var regExp = new RegExp('__' + key + '__', 'gi');
		var temp = [];

		if (!Array.isArray(oKeys[key])) oKeys[key] = [oKeys[key]];

		oKeys[key].forEach(function (item) {
			/* eslint-disable */
			/**
    * ключи нужно писать с namespace-ами, чтоб небыло пересечений
    */
			switch (key) {
				case 'iw-metro':
					temp.push('\n\t\t\t\t\t\t' + (item.is ? '\n\t\t\t\t\t\t\t<div class="gcell gcell--auto _flex-noshrink">\n\t\t\t\t\t\t\t\t<div class="building-card__metro ' + (item.name ? 'has-tooltip' : '') + '">\n\t\t\t\t\t\t\t\t\t<i class="svgi svgi--metro _fill-metro-' + item.type + '">\n\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 20 20" width="20" height="20"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#metro"></use></svg>\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t\t' + (item.name ? '\n\t\t\t\t\t\t\t\t\t\t<div class="tooltip tooltip--top tooltip--sm tooltip--white tooltip--building-card building-card__tooltip">\n\t\t\t\t\t\t\t\t\t\t\t<span class="tooltip__text">' + item.name + '</span>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t' : '') + '\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t' : '') + '\n\t\t\t\t\t');
					break;

				case 'iw-price':
					temp.push('\n\t\t\t\t\t\t<div class="grid grid--vspaces-sm _items-baseline">\n\t\t\t\t\t\t\t' + Object.keys(item).map(function (price) {
						if (price.toLocaleLowerCase() === 'full') {
							return '\n\t\t\t\t\t\t\t\t\t\t<div class="gcell gcell--auto">\n\t\t\t\t\t\t\t \t\t\t\t<div class="building-card__price-full mark mark--yellow">' + item[price] + '</div>\n\t\t\t\t\t\t\t \t\t\t</div>\n\t\t\t\t\t\t\t\t\t';
						} else if (price.toLocaleLowerCase() === 'part') {
							return '\n\t\t\t\t\t\t\t\t\t\t<div class="gcell gcell--auto">\n\t\t\t\t\t\t\t \t\t\t\t<div class="building-card__price-part">(' + item[price] + ')</div>\n\t\t\t\t\t\t\t \t\t\t</div>\n\t\t\t\t\t\t\t\t\t';
						}
					}).join('') + '\n\t\t\t\t\t\t</div>\n\t\t\t\t\t');
					break;

				case 'ss-list':
					temp.push('\n\t\t\t\t\t\t<li class="site-search__suggestion-item">\n\t\t\t\t\t\t\t<div class="site-search__icon">\n\t\t\t\t\t\t\t\t' + (item.hint ? '\n\t\t\t\t\t\t\t\t\t<i class="svgi svgi--building">\n\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 18 18" width="18" height="18"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#jk"></use></svg>\n\t\t\t\t\t\t\t\t\t</i>\n\t\t\t\t\t\t\t\t' : '<i class="svgi svgi--developer">\n\t\t\t\t\t\t\t\t\t\t<svg viewBox="0 0 18 18" width="18" height="18"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="/Media/assets/images/sprites/icons.svg#zastrou"></use></svg>\n\t\t\t\t\t\t\t\t\t</i>') + '\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t<a href="' + item.link + '" class="site-search__suggestion-link">' + item.name + '</a>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t' + (item.hint ? '\n\t\t\t\t\t\t\t\t<div class="site-search__suggestion-hint">' + item.hint + '</div>\n\t\t\t\t\t\t\t' : '') + '\n\t\t\t\t\t\t</li>\n\t\t\t\t\t');
					break;

				default:
					buffer = buffer.replace(regExp, oKeys[key]);
					break;
			}
		});

		buffer = buffer.replace(regExp, temp.join(''));
	});

	return buffer;
}

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = prepareIncomingData;
function prepareIncomingData(data) {
	try {
		var temp = void 0;

		if (typeof data === 'string') {
			temp = JSON.parse(data);
		} else {
			temp = JSON.parse(JSON.stringify(data));
		}

		return temp;
	} catch (err) {
		console.group('Incorrect data format');
		console.error(err, '\n');
		console.log(data, '\n');
		console.groupEnd('Incorrect data format');

		return new Error('Некорректный формат данных');
	}
}

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = getResponsiveParams;
/**
 * Расчет колва слайдов при адаптации
 * @param {Number} [slideWidth] - ширина слайда
 * @param {Number} [maxSlideCount] - максимальное число слайдов для отображения
 * @param {String} [sliderType = 'siema'] - тип сладера. Доступные варианты: 'siema', 'slick'
 * @returns {Array | Object}
 */
function getResponsiveParams(slideWidth, maxSlideCount) {
	var sliderType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'siema';

	if (sliderType === 'siema') {
		var oResponsiveParams = {};
		for (var i = 1; i <= maxSlideCount; i++) {
			oResponsiveParams[slideWidth * i] = i;
		}
		return oResponsiveParams;
	} else if (sliderType === 'slick') {
		var arrResponsiveParams = [];
		for (var _i = 1; _i <= maxSlideCount; _i++) {
			arrResponsiveParams.push({
				breakpoint: slideWidth * _i,
				settings: {
					slidesToShow: _i
				}
			});
		}
		return arrResponsiveParams;
	}
}

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Создание таймеров с внутреним замыканием
 * @module
 * @example
import createTimer from './create-timer';

let timer = createTimer(500);
$(window).on('resize', function () {
	timer(() => {
		console.log('done');
	});
});

// only clear timeout
timer.clear();
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {number} [defaultDelay=300]
 * @return {timer} запуск таймеров
 */

Object.defineProperty(exports, "__esModule", {
	value: true
});
function createTimer() {
	var defaultDelay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 300;

	var timerId = null;
	var _window = window,
	    clearTimeout = _window.clearTimeout,
	    setTimeout = _window.setTimeout;

	/**
  * @param {Function} fn
  * @param {number} [delay=defaultDelay]
  * @prop {Function} clear
  */

	function timer(fn) {
		var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultDelay;

		clearTimeout(timerId);
		timerId = setTimeout(fn, delay);
	}

	timer.clear = function () {
		return clearTimeout(timerId);
	};
	return timer;
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = createTimer;

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Пользовательские обработчики формы
 * @module
 */

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {JQuery} $form
 * @param {Object} Validator {@link https://jqueryvalidation.org/?s=validator}
 * @param {Function} Validator.resetForm {@link https://jqueryvalidation.org/Validator.resetForm/}
 * @param {Function} Validator.element {@link https://jqueryvalidation.org/Validator.element/}
 */

Object.defineProperty(exports, "__esModule", {
	value: true
});
function setHandlers($form, Validator) {
	// сабмит формы, блок отправки при ошибке скриптов
	var method = $form.attr('method') || 'post';
	$form.prop('method', method);
	$form.on('submit', function (event) {
		return event.preventDefault();
	});

	// сброс формы
	$form.on('reset', function () {
		return Validator.resetForm();
	});

	// проверка файлов, при смене
	$form.on('change', 'input[type="file"]', function () {
		Validator.element(this);
	});

	// дальше ваш код
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = setHandlers;

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Маска телефонов
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(362);

__webpack_require__(67);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * @param {JQuery} $input
 * @return {string}
 * @private
 */
function getMask($input) {
	var _$input$data = $input.data(),
	    _$input$data$phonemas = _$input$data.phonemask,
	    phonemask = _$input$data$phonemas === undefined ? '+38(999) 99-99-999' : _$input$data$phonemas,
	    _$input$data$phonemas2 = _$input$data.phonemaskAndroid,
	    phonemaskAndroid = _$input$data$phonemas2 === undefined ? '+389999999999' : _$input$data$phonemas2;

	return window.Modernizr.android ? phonemaskAndroid : phonemask;
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @param {JQuery|null} [$container=null]
 */
function phoneMask() {
	var $container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

	$('[data-phonemask]', $container).each(function (i, input) {
		var $input = $(input);

		if ($input.hasInitedKey('inputmask-inited')) {
			return true;
		}

		var isComplete = function isComplete() {
			return $input.data('valid', $input.inputmask('isComplete'));
		};
		$input.inputmask({
			mask: getMask($input),
			// clearMaskOnLostFocus: false,
			oncomplete: function oncomplete() {
				$input.data('valid', true);
			},
			onincomplete: function onincomplete() {
				$input.data('valid', false);
			}
		}).on('change.isComplete', isComplete);
	});
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = phoneMask;

/***/ }),

/***/ 363:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип ajax
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#ajax-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _validate = __webpack_require__(137);

var _validate2 = _interopRequireDefault(_validate);

var _horizontalScroll = __webpack_require__(136);

var _horizontalScroll2 = _interopRequireDefault(_horizontalScroll);

var _wrapMedia = __webpack_require__(138);

var _wrapMedia2 = _interopRequireDefault(_wrapMedia);

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {string} [selector=".js-mfp-ajax"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	var config = $.extend(true, {
		mainClass: 'mfp-animate-zoom-in',
		type: 'ajax',
		removalDelay: 300,
		callbacks: {
			elementParse: function elementParse(item) {
				var _item$el$data = item.el.data(),
				    url = _item$el$data.url,
				    _item$el$data$type = _item$el$data.type,
				    type = _item$el$data$type === undefined ? 'POST' : _item$el$data$type,
				    _item$el$data$param = _item$el$data.param,
				    data = _item$el$data$param === undefined ? {} : _item$el$data$param;

				this.st.ajax.settings = { url: url, type: type, data: data };
			},
			ajaxContentAdded: function ajaxContentAdded() {
				var $container = this.contentContainer || [];
				if ($container) {
					(0, _horizontalScroll2.default)('.wysiwyg table', $container);
					(0, _wrapMedia2.default)('.wysiwyg iframe, .wysiwyg video', $container);
					(0, _validate2.default)('.js-form', $container);
				}
			}
		}
	}, userConfig);

	$context.find(selector).magnificPopup(config);

	$('body').on('click', '[data-mfp-close]', function () {
		$.magnificPopup.close();
	});

	$context.each(function (i, el) {
		var $element = $(el);

		$(document).on('galleryClose', function () {
			if ($element.is($.magnificPopup.instance.ev[0])) {
				$($.magnificPopup.instance.wrap).trigger('click');
				$element.on('mfpClose', function () {
					$(document).trigger('galleryClosed');
				});
			} else {
				$(document).trigger('galleryClosed');
			}
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {string} [selector=".js-mfp-ajax"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpAjax() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-ajax';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 69)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.trigger(event.type);
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpAjax;

/***/ }),

/***/ 364:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип inline
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#inline-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {JQuery.Selector|JQuery} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	/**
  * @type {JQuery}
  */
	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $element = $(el);
		var config = $.extend(true, {
			type: 'inline',
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in',
			callbacks: {
				beforeOpen: function beforeOpen() {
					if (!$element.parent().data('slide-count')) {
						if (typeof parseInt($element.parent('[data-slide]').data('slide')) === 'number') {
							window.popupSlide = parseInt($element.parent('[data-slide]').data('slide')) || 0;
						}
					} else {
						if (typeof parseInt($element.parent('[data-slide-count]').data('slide-count')) === 'number') {
							window.popupSlide = parseInt($element.parent('[data-slide-count]').data('slide-count')) || 0;
						}
					}
					$(document).trigger('currentSlideUpdated');
				}
			}
		}, userConfig);

		$element.magnificPopup(config);

		$(document).on('galleryClose', function () {
			if ($element.is($.magnificPopup.instance.ev[0])) {
				$($.magnificPopup.instance.wrap).trigger('click');
				$element.on('mfpClose', function () {
					$(document).trigger('galleryClosed');
				});
			} else {
				$(document).trigger('galleryClosed');
			}
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {JQuery.Selector} [selector=".js-mfp-inline"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpInline() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-inline';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	/**
  * @param {JQuery.Event} event
  */
	function load(event) {
		event.preventDefault();
		// $context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 69)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.magnificPopup('open');
			$(document).trigger('popupSliderUpdate');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpInline;

/***/ }),

/***/ 365:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит магнифика, тип iframe
 * @module
 * @see {@link http://dimsemenov.com/plugins/magnific-popup/documentation.html#iframe-type}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Инит метода
 * @param {JQuery.Selector|JQuery} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @private
 * @sourceCode
 */
function init(selector, $context, userConfig) {
	/**
  * @type {JQuery}
  */
	var $elements = selector && selector.jquery ? selector : $(selector, $context);
	$elements.each(function (i, el) {
		var $element = $(el);
		var config = $.extend(true, {
			type: 'iframe',
			closeBtnInside: true,
			removalDelay: 300,
			mainClass: 'mfp-animate-zoom-in'
		}, userConfig);

		$element.magnificPopup(config);

		$(document).on('galleryClose', function () {
			if ($element.is($.magnificPopup.instance.ev[0])) {
				$($.magnificPopup.instance.wrap).trigger('click');
				$element.on('mfpClose', function () {
					$(document).trigger('galleryClosed');
				});
			} else {
				$(document).trigger('galleryClosed');
			}
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Загрузка по требованию
 * @param {JQuery.Selector} [selector=".js-mfp-iframe"]- поиск элементов по селектору
 * @param {JQuery} [$context=$('body')] - контекст в котором будет выполнен поиск селектора
 * @param {Object} [userConfig={}] - пользовательский конфиг
 * @sourceCode
 */
function mfpIframe() {
	var selector = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '.js-mfp-iframe';
	var $context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $('body');
	var userConfig = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	/**
  * @param {JQuery.Event} event
  */
	function load(event) {
		event.preventDefault();
		$context.off('click', selector, load);

		var $element = $(this);
		var preloader = new _Preloader2.default($element);
		preloader.show();

		__webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 69)).then(function () {
			init(selector, $context, userConfig);
			preloader.hide();
			$element.magnificPopup('open');
		});
	}

	$context.on('click', selector, load);
}

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = mfpIframe;

/***/ }),

/***/ 366:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Wezom Standard Tabs
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

__webpack_require__(367);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Не реагировать на клик
 * @param {JQuery} $button
 * @return {boolean|undefined}
 * @private
 */
function noReact($button) {
	return $button.hasClass(wsTabs.cssClass.active) || $button.hasClass(wsTabs.cssClass.disabled) || $button.prop('disabled');
}

/**
 * @param {JQuery} $button
 * @param {JQuery} $context
 * @private
 */
function changeTab($button, $context) {
	var myNs = $button.data(wsTabs.keys.ns);
	var myName = $button.data(wsTabs.keys.button);

	var buttonsSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.button + ']';
	var blocksSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.block + ']';
	var blockSelector = '[data-' + wsTabs.keys.ns + '="' + myNs + '"][data-' + wsTabs.keys.block + '="' + myName + '"]';

	/**
  * @type {JQuery}
  */
	var $block = $button.getMyElements(wsTabs.keys.myBlock, blockSelector);
	if (noReact($button)) {
		$button.add($block).trigger(wsTabs.events.again);
		return false;
	}

	/**
  * @type {JQuery}
  */
	var $siblingBlocks = $block.getMyElements(wsTabs.keys.myBlocks, blocksSelector, $context, true);

	/**
  * @type {JQuery}
  */
	var $siblingButtons = $button.getMyElements(wsTabs.keys.myButtons, buttonsSelector, $context, true);

	$siblingButtons.add($siblingBlocks).removeClass(wsTabs.cssClass.active).trigger(wsTabs.events.off);
	$button.add($block).addClass(wsTabs.cssClass.active).trigger(wsTabs.events.on);
}

/**
 * Активация табов, если нету активных
 * @param {JQuery} $buttons
 * @param {JQuery} $context
 * @private
 */
function setActiveIfNotHave($buttons, $context) {
	var ns = $buttons.data(wsTabs.keys.ns);
	var selector = '[data-' + wsTabs.keys.ns + '="' + ns + '"]';
	var $group = $buttons.filter(selector);

	if ($group.length) {
		var $active = $group.filter('.' + wsTabs.cssClass.active);
		if (!$active.length) {
			changeTab($group.eq(0), $context);
		}

		if ($group.length < $buttons.length) {
			setActiveIfNotHave($buttons.not(selector), $context);
		}
	}
}

/**
 * Сброс зависимолстей
 * @param {JQuery} $list
 * @param {Array.<string>} keys
 * @private
 */
function _dropDependencies($list, keys) {
	$list.each(function (i, el) {
		var $item = $(el);
		wsTabs.keys.forEach(function (key) {
			$item.data(key, null);
		});
	});
}

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * @namespace
 */
var wsTabs = {
	/**
  * События
  * @enum {string}
  * @sourceCode
  */
	events: {
		on: 'wstabs-on',
		off: 'wstabs-off',
		again: 'wstabs-again'
	},

	/**
  * CSS классы
  * @enum {string}
  * @sourceCode
  */
	cssClass: {
		active: 'is-active',
		disabled: 'is-disabled'
	},

	/**
  * Ключи
  * @enum {string}
  * @sourceCode
  */
	keys: {
		ns: 'wstabs-ns',
		button: 'wstabs-button',
		block: 'wstabs-block',
		myBlock: '$myWsTabsBlock',
		myBlocks: '$myWsTabsBlocks',
		myButtons: '$myWsTabsButtons'
	},

	/**
  * Инициализация
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	init: function init() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		$context.on('click', '[data-' + wsTabs.keys.button + ']', { $context: $context }, function (event) {
			event.preventDefault();
			changeTab($(this), $context);
		});
	},


	/**
  * Принудительная активация табов, если нету активных
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	setActive: function setActive() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		var $buttons = $context.find('[data-' + wsTabs.keys.button + ']');
		setActiveIfNotHave($buttons, $context);
	},


	/**
  * Сброс всех связей.
  * Актуально при динамическом добавление новый кнопок и блоков в уже существующие группы табов
  * @param {JQuery} [$context=$(document)]
  * @sourceCode
  */
	dropDependencies: function dropDependencies() {
		var $context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $(document);

		var $buttons = $context.find('[data-' + wsTabs.keys.button + ']');
		var $blocks = $context.find('[data-' + wsTabs.keys.block + ']');
		_dropDependencies($buttons, [wsTabs.keys.myBlock, wsTabs.keys.myButtons]);
		_dropDependencies($blocks, [wsTabs.keys.myBlocks]);
	}
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = wsTabs;

/***/ }),

/***/ 368:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _noty = __webpack_require__(369);

var _noty2 = _interopRequireDefault(_noty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_noty2.default.setMaxVisible(5);

_noty2.default.overrideDefaults({
	theme: 'vsenovostroyki',
	timeout: 1000
});

var Notifier = function (_Noty) {
	_inherits(Notifier, _Noty);

	function Notifier() {
		_classCallCheck(this, Notifier);

		return _possibleConstructorReturn(this, (Notifier.__proto__ || Object.getPrototypeOf(Notifier)).apply(this, arguments));
	}

	_createClass(Notifier, null, [{
		key: 'create',
		value: function create(options) {
			return new _noty2.default(options);
		}
	}, {
		key: 'prepareOptions',
		value: function prepareOptions() {
			var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
			var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

			var opts = void 0;
			if ((typeof text === 'undefined' ? 'undefined' : _typeof(text)) === 'object') {
				opts = text;
			} else if (typeof text === 'string' && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
				opts = Object.assign(options, { text: text });
			} else {
				console.error('Incorrect types of arguments');
			}
			return opts;
		}
	}, {
		key: 'info',
		value: function info(text, options) {
			this.create(Object.assign(this.prepareOptions(text, options), { type: 'info' })).show();
		}
	}, {
		key: 'alert',
		value: function alert(text, options) {
			this.create(Object.assign(this.prepareOptions(text, options), { type: 'alert' })).show();
		}
	}, {
		key: 'error',
		value: function error(text, options) {
			this.create(Object.assign(this.prepareOptions(text, options), { type: 'error' })).show();
		}
	}, {
		key: 'success',
		value: function success(text, options) {
			this.create(Object.assign(this.prepareOptions(text, options), { type: 'success' })).show();
		}
	}, {
		key: 'warning',
		value: function warning(text, options) {
			this.create(Object.assign(this.prepareOptions(text, options), { type: 'warning' })).show();
		}
	}, {
		key: 'echo',
		value: function echo() {
			// Notifier.alert('alert', {timeout: 5000});
			// Notifier.info('info', {timeout: 5000});
			// Notifier.success('success', {timeout: 5000});
			// Notifier.warning('warning', {timeout: 5000});
			// Notifier.error('error', {timeout: 5000});
			Notifier.alert('alert', { timeout: false });
			Notifier.info('info', { timeout: false });
			Notifier.success('success', { timeout: false });
			Notifier.warning('warning', { timeout: false });
			Notifier.error('error', { timeout: false });
		}
	}]);

	return Notifier;
}(_noty2.default);

exports.default = Notifier;

/***/ }),

/***/ 371:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = toggle;

var _cookieData = __webpack_require__(96);

var _cookieData2 = _interopRequireDefault(_cookieData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param $toggler
 */
function filterCookie($toggler) {
	var data = $toggler.data('filter-cookie');
	if (data) {
		var add = $toggler.hasClass('is-active');
		if (add) {
			if (!_cookieData2.default.receive(data.name)) {
				_cookieData2.default.add(data.name, data.value, { path: '/' });
			}
		} else {
			_cookieData2.default.add(data.name, 0, { expires: -1, path: '/' });
		}
	}
}

function toggle($togglers) {
	$togglers.each(function (i, toggler) {
		var $toggler = $(toggler);
		var ns = i;
		var presetList = window.projectConfig.plugin.toggle.preset;
		var currentPreset = $toggler.data('toggle');
		// let params = (typeof currentPreset === 'string' && currentPreset in presetList) ? presetList[currentPreset] : currentPreset;
		var params = null;

		if (typeof currentPreset === 'string') {
			if (currentPreset in presetList) {
				params = presetList[currentPreset];
			} else {
				console.warn('Invalid preset [' + currentPreset + '] for $toggler\n', $toggler);
				return;
			}
		} else {
			params = currentPreset;
		}

		var _params = params,
		    _params$context = _params.context,
		    context = _params$context === undefined ? $toggler.parent() : _params$context,
		    _params$map = _params.map,
		    map = _params$map === undefined ? {} : _params$map,
		    _params$opening = _params.opening,
		    opening = _params$opening === undefined ? [] : _params$opening,
		    _params$closing = _params.closing,
		    closing = _params$closing === undefined ? [] : _params$closing,
		    _params$stops = _params.stops,
		    stops = _params$stops === undefined ? [] : _params$stops,
		    _params$focusTarget = _params.focusTarget,
		    focusTarget = _params$focusTarget === undefined ? null : _params$focusTarget,
		    _params$clearInputs = _params.clearInputs,
		    clearInputs = _params$clearInputs === undefined ? null : _params$clearInputs,
		    _params$toggleOnBlur = _params.toggleOnBlur,
		    toggleOnBlur = _params$toggleOnBlur === undefined ? true : _params$toggleOnBlur,
		    _params$onlyOne = _params.onlyOne,
		    onlyOne = _params$onlyOne === undefined ? true : _params$onlyOne;

		var $body = $('body');
		var toggle = function toggle(map, action, cb) {
			Object.keys(map).forEach(function (selector) {
				var $node = null;

				if (/^html|body$/.test(selector)) {
					$node = $(selector);
				} else {
					$node = $(selector, context);
				}

				$node[action](map[selector]);
			});
			if (/^removeClass$/.test(action)) {
				$body.removeClass('waiting-for-tap');
			}
			if (cb) {
				cb();
			}
		};

		$toggler.data('ns', ns);

		opening.push($toggler.get(0));
		opening.forEach(function (selector) {
			$(selector).on('click.toggle.open' + ns, function (e) {
				e.preventDefault();
				e.stopPropagation();

				if (onlyOne && !$toggler.data('is-open')) {
					$toggler.data('is-open', false);
					$(document).trigger('click.toggle.close');
				}

				toggle(map, 'toggleClass', function () {
					$toggler.data('is-open', true);
					filterCookie($toggler);

					if (focusTarget) {
						$(focusTarget).focus();
					}
					if (clearInputs && clearInputs.length) {
						clearInputs.forEach(function (selector) {
							var $selector = $(selector, context);
							var $currentForm = $selector.closest('.js-form');
							var validator = $currentForm.data('validator');
							$selector.val('');
							if (validator !== 'undefined') {
								validator.resetElements($selector);
							}
						});
					}
					if ($toggler.hasClass('select-box--single')) {
						/**
       * В данном случае, нужно чтобы выпадайка с опциями закрылась после выбора опции
       * но с запозданием, чтоб прошел клик в выбранный элемент или ссылку или что там будет
       */
						stops.forEach(function (selector) {
							$(selector).on('click' + ns, function (e) {
								var tm = null;
								clearTimeout(tm);
								tm = setTimeout(function () {
									toggle(map, 'removeClass');
								}, 300);
							});
						});
					}
					/**
      * Проверяем девайс (тач|не тач)(apple|не apple) и исходя из типа девайса вешать на body курсор поинтер или нет
      * Нужно для того, чтобы клик по документу нормально отрабатывал на apple девайсах (iphone/ipad)
      */
					if (window.Modernizr.touchevents && (window.Modernizr.iphone || window.Modernizr.ipad || window.Modernizr.ios)) {
						$body.addClass('waiting-for-tap');
					}
				});
			});
		});

		if (closing.length) {
			closing.forEach(function (selector) {
				$(selector).on('click.toggle.close' + ns, function () {
					toggle(map, 'removeClass');
				});
			});
		}

		if (toggleOnBlur) {
			stops.forEach(function (selector) {
				$(selector).on('click.toggle.stopBubble' + ns, function (e) {
					e.stopPropagation();
				});
			});
		}

		if (toggleOnBlur || onlyOne) {
			$(document).on('click.toggle.close', function () {
				$toggler.data('is-open', false);
				toggle(map, 'removeClass');
			});
		}
	});
}

/***/ }),

/***/ 372:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = switchText;
function switchText($elems) {
	$elems.each(function (i, el) {
		var $el = $(el);
		var index = 0;
		var arrText = $el.data('switch-text');
		var swt = function swt($node) {
			$node.text(arrText[index]);
			index++;
			if (index >= arrText.length) {
				index = 0;
			}
		};

		swt($el.is('.button') ? $el.find('.button__text') : $el);

		$el.on('click.switch-text', function (e) {
			var $this = $(e.currentTarget);
			swt($this.is('.button') ? $this.find('.button__text') : $this);
		});
	});
}

/***/ }),

/***/ 373:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = selectBox;

var _debounce = __webpack_require__(68);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function selectBox($selectBoxes) {
	var update = function update($currentBox) {
		var initiator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'self';

		var boxType = $currentBox.data('select-box');
		var $boxHeading = $currentBox.find('[data-select-box-heading]');
		var $boxChecked = $currentBox.find('[data-select-box-checked]');
		var arrChecked = [];
		var textChecked = $boxHeading.data('checked-text');
		var textNonChecked = $boxHeading.data('non-checked-text');
		var $fields = $currentBox.find('.control__field');

		if (/^self$/i.test(initiator)) {
			if (boxType === 'single') {
				$fields.closest('.select-box__item').removeClass('is-disabled');
			}
		}

		$fields.filter(function () {
			return this.checked;
		}).each(function (i, field) {
			var $field = $(field);

			arrChecked.push($field.closest('.control').find('.control__text').text());

			if (boxType === 'single') {
				$field.closest('.select-box__item').addClass('is-disabled');
			}
		});

		if (arrChecked.length) {
			$boxChecked.text(arrChecked.join(', '));

			if (boxType !== 'single') {
				$boxHeading.attr('title', textChecked + ': \n' + arrChecked.map(function (value) {
					return '\u2713 ' + value;
				}).join('\n'));
			}
		} else {
			$boxChecked.text(textNonChecked);

			if (boxType !== 'single') {
				$boxHeading.attr('title', textNonChecked);
			}
		}
	};

	var reset = function reset($currentBox) {
		var initiator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'self';

		var boxType = $currentBox.data('select-box');
		var $boxHeading = $currentBox.find('[data-select-box-heading]');
		var $boxChecked = $currentBox.find('[data-select-box-checked]');
		var textNonChecked = $boxHeading.data('non-checked-text');
		var $fields = $currentBox.find('.control__field');

		$fields.each(function (i, field) {
			var $field = $(field);

			$field.prop('checked', false);
			$field.prop('disabled', false);

			if (boxType === 'single') {
				$field.closest('.select-box__item').removeClass('is-disabled');
			}
		});

		$boxChecked.text(textNonChecked);

		if (boxType !== 'single') {
			$boxHeading.attr('title', textNonChecked);
		}

		$(document).trigger('click.toggle.close');
	};

	$selectBoxes.each(function (i, box) {
		var $box = $(box);

		update($box);

		$box.data('updateBox', update);
		$box.data('resetBox', reset);

		$box.on('click change', 'input', function (e) {
			var $thisBox = $(e.delegateTarget);

			update($thisBox);

			setTimeout(function () {
				$(e.target).closest('.select-box__item').addClass('is-active');
			}, 300);
		});
	});

	$selectBoxes.closest('form').on('reset', (0, _debounce2.default)(function () {
		$selectBoxes.each(function (i, box) {
			update($(box));
		});
	}, 20));
}

/***/ }),

/***/ 382:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = scrollToElement;
/**
 * Скролим к элементу, заданному в атрибуте data-scroll-to.
 * @param {string|HTMLElement|jQuery} $targetOrSelector
 * @param options
 * @param callback
 */
function scrollToElement($targetOrSelector) {
	var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

	var $target = $($targetOrSelector);
	if (!$target.length) {
		console.warn('Target ' + $targetOrSelector + ' was not found');
		return false;
	}
	var _options$speed = options.speed,
	    speed = _options$speed === undefined ? 2000 : _options$speed;
	// let headerHeight = $('.header').outerHeight();

	var scrollTop = $(window).scrollTop();
	var destination = $target.offset().top - 30; // - headerHeight;
	destination = destination < 0 ? 0 : destination;
	var delta = Math.abs(destination - scrollTop);
	var duration = delta / speed * 1000;
	$('html, body').stop().animate({
		scrollTop: destination
	}, {
		duration: duration,
		done: callback
	});
	return false;
}

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = close;
function close($closeElems) {
	$closeElems.each(function (i, root) {
		var $root = $(root);

		$root.on('click.close', '[data-close="trigger"]', function (e) {
			var $thisRoot = $(e.delegateTarget);

			$thisRoot.fadeOut(300);
		});
	});
}

/***/ }),

/***/ 384:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = siteSearch;

var _LiveSearch = __webpack_require__(385);

var _LiveSearch2 = _interopRequireDefault(_LiveSearch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function siteSearch($siteSearchElems) {
	$siteSearchElems.each(function (i, root) {
		var $root = $(root);
		var inlineConfig = $root.data('inline-config') || {};

		/* eslint-disable no-unused-vars */
		var siteSearch = new _LiveSearch2.default($root, inlineConfig);
	});
}

/***/ }),

/***/ 385:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(68);

var _debounce2 = _interopRequireDefault(_debounce);

var _utils = __webpack_require__(134);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LiveSearch = function () {
	function LiveSearch($root) {
		var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, LiveSearch);

		var defaults = {
			$root: $root,
			$form: $root.find('[data-live-search="form"]'),
			$input: $root.find('[data-live-search="input"]'),
			$suggestion: $root.find('[data-live-search="suggestion"]'),
			$sContent: $root.find('[data-live-search="suggestion-content"]'),
			$sSection: $root.find('[data-live-search="suggestion-section"]').detach(),
			$allResults: $root.find('[data-live-search="all-results"]'),
			$allResultsLink: $root.find('[data-live-search="all-results-link"]'),
			$city: $root.find('[data-live-search="city"]'),
			$cityLink: $root.find('[data-live-search="city-link"]'),
			css: {
				hasResult: 'has-result',
				hasSuccess: 'has-success',
				hasError: 'has-error',
				shortQuery: 'short-query'
			},
			message: {
				zeroResults: $root.data('zero-results') || 'Нет результатов поиска'
			},
			minQueryLength: 3
		};
		window.liveSearchInstance = null;
		this.params = $.extend(true, {}, defaults, options);
		this.$document = $(document);
		this.$window = $(window);
		this.query = this.params.$input.val() || null;
		this.lastRenderHasSuccess = false;
		this.init();
	}

	_createClass(LiveSearch, [{
		key: 'init',
		value: function init() {
			this.addListeners();
		}
	}, {
		key: 'addListeners',
		value: function addListeners() {
			var _this = this;

			var _self = this;
			var route = window.projectConfig.route.ajax.livesearch;

			this.params.$input.on('input', (0, _debounce2.default)(function (e) {
				if (e.keyCode === 13) {
					_this.params.$form.submit();
					return;
				}

				_this.query = e.target.value.trim();

				if (_this.query && _this.query.length >= _this.params.minQueryLength) {
					$.ajax({
						type: 'POST',
						url: route,
						data: {
							query: _this.query
						}
					}).done(function (res) {
						res = (0, _utils.prepareIncomingData)(res);
						_self.render(res).then(function () {
							_this.toggle('open');
						}).catch(function (err) {
							_this.toggle('error', err);
						});
					}).fail(function (err) {
						console.warn('Ошибка загрузки данных', err);
					}).always(function () {});
				} else if (!_this.query) {
					_this.toggle('close');
				} else {
					_this.toggle('short-query');
				}
			}, 300)).on('focus', function () {
				_this.switchInstance();
				if (!_this.query) {
					_this.toggle('close');
				} else if (_this.query && _this.query.length >= _this.params.minQueryLength && !_this.lastRenderHasSuccess) {
					_this.toggle('search');
				} else if (_this.query && _this.query.length >= _this.params.minQueryLength && _this.lastRenderHasSuccess) {
					_this.toggle('open');
				} else {
					_this.toggle('short-query');
				}
			});

			this.params.$form.on('reset', function () {
				_this.query = null;
			});

			this.params.$form.on('submit', function (e) {
				if (_this.query && _this.query.length < _this.params.minQueryLength) {
					e.preventDefault();
					_this.toggle('short-query');
				}
			});

			this.params.$root.on('click.live-search.stopBubble', function (e) {
				e.stopPropagation();
			});

			this.$document.on('click.live-search.close click.toggle.close', function () {
				_this.toggle('close');
			});

			$('[data-live-search="close"]').on('click', function () {
				_this.$document.trigger('click.live-search.close');
			});

			this.$window.on('resize', (0, _debounce2.default)(function () {
				_this.$document.trigger('click.live-search.close');
			}, 150));
		}
	}, {
		key: 'toggle',
		value: function toggle() {
			var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
			var err = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

			if (!action) {
				return;
			}

			var _params$css = this.params.css,
			    hasResult = _params$css.hasResult,
			    hasSuccess = _params$css.hasSuccess,
			    hasError = _params$css.hasError,
			    shortQuery = _params$css.shortQuery;


			switch (action) {
				case 'short-query':
					this.params.$root.removeClass(hasResult + ' ' + hasSuccess + ' ' + hasError).addClass(shortQuery);
					break;
				case 'search':
					this.params.$input.trigger('input');
					break;
				case 'open':
					this.switchInstance();
					this.lastRenderHasSuccess = true;
					this.params.$root.removeClass(shortQuery).addClass(hasResult + ' ' + hasSuccess);
					break;
				case 'close':
					this.params.$root.removeClass(hasResult + ' ' + hasSuccess + ' ' + hasError + ' ' + shortQuery);
					break;
				case 'error':
					this.lastRenderHasSuccess = false;
					this.params.$root.removeClass(hasResult + ' ' + hasSuccess + ' ' + shortQuery).addClass(hasError);
					if (err) {
						console.warn(err);
					}
					break;
				default:
					break;
			}
		}
	}, {
		key: 'switchInstance',
		value: function switchInstance() {
			if (window.liveSearchInstance) {
				window.liveSearchInstance.toggle('close');
			}
			window.liveSearchInstance = this;
		}
	}, {
		key: 'search',
		value: function search() {
			this.params.$input.trigger('input');
		}
	}, {
		key: 'render',
		value: function render(data) {
			var _this2 = this;

			data = (0, _utils.prepareIncomingData)(data);

			return new Promise(function (resolve, reject) {
				if (data instanceof Error) {
					reject(data);
				}

				/**
     * Если передана кастомная функция для рендера результата поиска, то вызываем ее, привязываем к ней контекст и передаем в нее данные по запросу
     * Иначе используем дефолтную функцию рендера
     */
				if (_this2.params.renderFunc) {
					_this2.params.renderFunc.call(_this2, data);
				} else {
					var content = [];
					var template = _this2.params.$sSection[0].outerHTML;

					data.results.forEach(function (responseItem) {
						content.push((0, _utils.setContent)(template, responseItem));
					});

					if (content.length) {
						_this2.params.$sContent[0].innerHTML = content.join('');
					} else {
						_this2.params.$sContent[0].innerHTML = '\n\t\t\t\t\t\t<div class="site-search__suggestion-section">\n\t\t\t\t\t\t\t<div class="site-search__suggestion-title">' + _this2.params.message.zeroResults + '</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t';
					}

					if (data['results-city']) {
						_this2.params.$cityLink.attr('href', data['results-city'].link);
						_this2.params.$cityLink.html(data['results-city'].name);
						_this2.params.$city.removeClass('_hide');
					} else {
						_this2.params.$city.addClass('_hide');
					}

					if (data['all-results-link'] && data['all-results-text']) {
						_this2.params.$allResultsLink.attr('href', data['all-results-link']);
						_this2.params.$allResultsLink.html(data['all-results-text']);
						_this2.params.$allResults.removeClass('_hide');
					} else {
						_this2.params.$allResults.addClass('_hide');
						_this2.params.$allResultsLink.removeAttr('href');
					}
				}

				resolve();
			});
		}
	}]);

	return LiveSearch;
}();

exports.default = LiveSearch;

/***/ }),

/***/ 386:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = scrollUp;
function scrollUp($buttons) {
	// let $document = $(document);
	var $window = $(window);
	var $htmlBody = $('html, body');
	var timeout = null;
	var checkScrollPos = function checkScrollPos($btn) {
		$btn.toggleClass('is-visible', $window.scrollTop() >= $window.height());
	};

	$buttons.each(function (i, btn) {
		var $btn = $(btn);

		checkScrollPos($btn);

		$btn.on('click', function () {
			$htmlBody.stop().animate({ scrollTop: 0 }, $btn.data('speed') || 750);
			return false;
		});

		$window.on('wheel', function () {
			$htmlBody.stop();
		}).on('scroll', function () {
			clearTimeout(timeout);

			timeout = setTimeout(function () {
				checkScrollPos($btn);
			}, 150);
		}).trigger('scroll');
	});
}

/***/ }),

/***/ 387:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = siteAccordion;

var _Accordion = __webpack_require__(388);

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function siteAccordion($elems) {
	$elems.each(function (i, root) {
		var $root = $(root);
		/* eslint-disable no-unused-vars */
		var accordion = new _Accordion2.default($root);
	});
}

/***/ }),

/***/ 388:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Accordion = function () {
	function Accordion(root) {
		var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Accordion);

		var $root = $(root);
		var defaults = {
			slideDuration: 400,
			activeClass: 'is-open',
			mode: 'default'
		};
		var inlineParams = $root.data('accordion') || {};

		this.$root = $root;
		this.$items = $root.find('[data-accordion="item"]');
		this.params = $.extend(true, {}, defaults, params, inlineParams);

		this.init();
	}

	_createClass(Accordion, [{
		key: 'init',
		value: function init() {
			var _this = this;

			this.$items.each(function (i, item) {
				var $item = $(item);
				var $trigger = $item.find('[data-accordion="trigger"]');
				var $content = $item.find('[data-accordion="content"]');

				$item.add($trigger).add($content).data({
					'item': $item,
					'trigger': $trigger,
					'content': $content
				});

				if (!$item.hasClass(_this.params.activeClass)) {
					$item.data('content').hide();
				}

				_this.listeners($item);
			});
		}
	}, {
		key: 'listeners',
		value: function listeners($item) {
			var _this2 = this;

			$item.data('trigger').on('click', function (e) {
				if (/^label|input$/.test(e.target.tagName.toLowerCase())) {
					return;
				}

				_this2.toggle($item);

				switch (_this2.params.mode) {
					case 'only_one':
						_this2.onOnlyOne($item);
						break;

					default:
						break;
				}
			});
		}
	}, {
		key: 'open',
		value: function open($item) {
			$item.addClass(this.params.activeClass);
			$item.data('content').slideDown(this.params.slideDuration);
		}
	}, {
		key: 'close',
		value: function close($item) {
			$item.removeClass(this.params.activeClass);
			$item.data('content').slideUp(this.params.slideDuration);
		}
	}, {
		key: 'toggle',
		value: function toggle($item) {
			if ($item.hasClass(this.params.activeClass)) {
				this.close($item);
			} else {
				this.open($item);
			}
		}
	}, {
		key: 'onOnlyOne',
		value: function onOnlyOne($currentItem) {
			var _this3 = this;

			this.$items.filter(function () {
				return this !== $currentItem[0];
			}).each(function (i, rest) {
				var $rest = $(rest);
				_this3.close($rest);
			});
		}
	}]);

	return Accordion;
}();

// export function loaderInit($elements) {
// 	$elements.each((i, element) => {
// 		let $element = $(element)
// 		if ($element.data('Accordion') instanceof Accordion === false) {
// 			$element.data('Accordion', new Accordion(element))
// 		}
// 	})
// }


exports.default = Accordion;

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Favorites = function () {
	function Favorites($trigger, $allTriggers) {
		_classCallCheck(this, Favorites);

		this.$trigger = $trigger;
		this.$card = null;
		if (!$trigger.data('ajax-type')) {
			this.route = window.projectConfig.route.ajax.favorites.default;
		} else {
			this.route = window.projectConfig.route.ajax.favorites.projects;
		}
		this.type = $trigger.data('favorites-type') || 'trigger-only';
		this.id = $trigger.data('complex-id') || null;
		this.$sameTriggers = $allTriggers.not(this.$trigger).filter('[data-complex-id="' + this.id + '"]');
		this.$favoritesBlock = $('[data-favorites-count]');

		if (this.type === 'card') {
			this.$card = this.$trigger.closest('[data-favorites-card]');
		}

		this.updateTriggers();
		this.addListeners();
	}

	_createClass(Favorites, [{
		key: 'updateTriggers',
		value: function updateTriggers() {
			var titles = this.$trigger.data('favorites-titles');

			if (this.$trigger.hasClass('is-in-favorites')) {
				this.$sameTriggers.add(this.$trigger).addClass('is-active').attr('title', titles[1]).find('.button__text').text(titles[1]);
			} else {
				this.$sameTriggers.add(this.$trigger).removeClass('is-active').attr('title', titles[0]).find('.button__text').text(titles[0]);
			}
		}
	}, {
		key: 'addListeners',
		value: function addListeners() {
			var _this = this;

			this.$trigger.on('click', function () {
				_this.$trigger.addClass('pending');
				var favoritesCount = _this.$favoritesBlock.attr('data-favorites-count');
				var isInFavorites = _this.$trigger.hasClass('is-in-favorites');

				if (/^card$/i.test(_this.type) && _this.$trigger.hasClass('is-in-favorites')) {
					_this.confirm().then(function (choice) {
						if (choice === 'remove') {
							_this.$favoritesBlock.attr('data-favorites-count', --favoritesCount);
							if (favoritesCount === 0) {
								_this.$favoritesBlock.removeClass('has-favorites');
							}
							_this.request();
						} else if (choice === 'cancel') {
							_this.clearInteractive();
							// perhaps some kind of logic, if the removal from the favorites was canceled
						}
					}).catch(function (err) {
						console.error(err);
						_this.clearInteractive();
					});
				} else {
					if (isInFavorites) {
						_this.$favoritesBlock.attr('data-favorites-count', --favoritesCount);
						if (favoritesCount === 0) {
							_this.$favoritesBlock.removeClass('has-favorites');
						}
					} else {
						_this.$favoritesBlock.addClass('has-favorites');
						_this.$favoritesBlock.attr('data-favorites-count', ++favoritesCount);
					}

					_this.request();
				}
			});
		}
	}, {
		key: 'request',
		value: function request() {
			var _self = this;

			return $.ajax({
				url: this.route,
				method: 'POST',
				data: {
					id: this.id
				}
			}).done(function (response) {
				_self.requestCallback(response);
				_self.clearInteractive(response);
			}).fail(function (err) {
				console.warn(err);
				_self.clearInteractive();
				window.Noty.error('Script error');
			}).always(function (response) {
				Favorites.updateSummary(response);
			});
		}
	}, {
		key: 'requestCallback',
		value: function requestCallback(response) {
			if (response.success) {
				if (response.action === 'add') {
					this.$trigger.addClass('is-in-favorites');
				} else if (response.action === 'remove') {
					this.$trigger.removeClass('is-in-favorites');

					if (this.type === 'card' && /favorites/gi.test(window.location.pathname)) {
						var $rootCell = this.$card.closest('.gcell');
						var reload = $rootCell.siblings('.gcell').length === 0;
						this.$card.fadeOut(300, function () {
							$rootCell.remove();
							if (reload) {
								window.location.reload();
							}
						});
					}
				}

				this.updateTriggers();

				if (response.message) {
					window.Noty.success(response.message);
				}
			}

			if (!response.success) {
				if (response.message) {
					window.Noty.error(response.message);
				}
			}
		}
	}, {
		key: 'clearInteractive',
		value: function clearInteractive() {
			this.$trigger.removeClass('pending');
		}
	}, {
		key: 'confirm',
		value: function confirm() {
			var _this2 = this;

			this.$card.addClass('confirm-is-open');
			return new Promise(function (resolve, reject) {
				_this2.$card.find('[data-confirm-action]').one('click.confirm', function (e) {
					var choice = $(e.currentTarget).data('confirm-action').toLocaleLowerCase();
					_this2.$card.removeClass('confirm-is-open');
					if (!/^remove$|^cancel$/i.test(choice)) {
						reject(new Error('\nSomething went wrong.\nChoice [remove] or [cancel] expected\nBut choice [' + choice + '] was received\n----------------------'));
					}
					resolve(choice);
				});
			});
		}
	}], [{
		key: 'updateSummary',
		value: function updateSummary() {
			var oInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (!oInfo) {
				return;
			}

			var $tooltip = $('[data-favorites-tooltip]');
			var $tooltipText = $tooltip.find('[data-tooltip-text]');
			var $favoritesCount = $('[data-favorites-count]');

			var totalCount = oInfo.count;
			var tooltipText = oInfo.count + '&nbsp;' + oInfo.text;

			if (totalCount > 0) {
				$favoritesCount.addClass('has-favorites');
				$tooltip.addClass('has-tooltip');
			} else {
				$favoritesCount.removeClass('has-favorites');
				$tooltip.removeClass('has-tooltip');
			}

			$favoritesCount.attr('data-favorites-count', totalCount);
			$tooltipText.html(tooltipText);
		}
	}]);

	return Favorites;
}();

exports.default = Favorites;

/***/ }),

/***/ 390:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = setCurrency;
function setCurrency($currencySetters) {
	var route = window.projectConfig.route.ajax.currencies;
	var setCurrency = function setCurrency(route, currency) {
		return $.ajax({
			url: route,
			type: 'POST',
			dataType: 'JSON',
			data: {
				param: currency
			}
		}).done(function (response) {
			if (response.success) {
				window.location.reload();
			}

			if (!response.success) {
				if (response.message) {
					window.Noty.error(response.message);
				} else {
					window.Noty.error('Currency Setting Error ');
				}
			}
		}).fail(function (err) {
			console.warn(err);
		}).always(function () {});
	};

	$currencySetters.each(function (i, root) {
		var $root = $(root);
		var $currency = $root.find('[data-currency]');

		$currency.on('click', function (e) {
			e.preventDefault();

			var $this = $(e.currentTarget);
			var currentCurrency = $this.data('currency');

			setCurrency(route, currentCurrency);
		});
	});
}

/***/ }),

/***/ 391:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = initFilter;

var _Filter = __webpack_require__(392);

var _Filter2 = _interopRequireDefault(_Filter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initFilter($filters) {
	$filters.each(function (i, root) {
		var $root = $(root);
		/* eslint-disable no-unused-vars */
		var filter = new _Filter2.default($root);
	});
}

/***/ }),

/***/ 392:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce = __webpack_require__(68);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Filter = function () {
	function Filter($filter) {
		_classCallCheck(this, Filter);

		this.$filter = $filter;
		this.$form = $filter.find('form');
		this.$preloader = $filter.find('[data-filter-preloader]');
		this.type = $filter.data('filter');
		this.locationPathName = window.location.pathname;
		this.route = window.projectConfig.route.ajax.filter[this.type];
		this.link = null;
		this.$allBoxes = $filter.find('[data-name-filter]');
		this.$submit = $filter.find('[data-filter-action="submit"]');
		this.$showAnotherView = $filter.find('[data-filter-action="another-view"]');
		this.$clearFilter = $filter.find('[data-filter-action="clear-filter"]');
		this.norerederfiel = null;

		this.init();
	}

	_createClass(Filter, [{
		key: 'init',
		value: function init() {
			this.addListeners();
		}
	}, {
		key: 'addListeners',
		value: function addListeners() {
			var _this2 = this;

			var _this = this;

			if (this.type === 'progress') {
				this.$allBoxes.filter('[data-route]').on('click change', 'input', function (e) {
					var $currentBox = $(e.delegateTarget);
					var $currentInput = $(e.currentTarget);
					var route = $currentBox.data('route');
					var params = {
						id: $currentBox.closest('[data-complex-id]').data('complex-id')
					};

					params[$currentBox.data('name-filter')] = $currentInput.val();

					$.post(route, params).then(function (response) {
						_this2.render(response);
					});
				});
			} else if (this.type === 'layout') {
				this.$filter.on('input', 'input[data-type="field"]', (0, _debounce2.default)(function () {
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.renderContent(response);
						_this2.preloader('hide');
					});
				}, 1000));

				$('#show_sold').on('change', function () {
					if (this.checked) {
						$('#show_sold_hidden').prop('disabled', true);
					} else {
						$('#show_sold_hidden').prop('disabled', false);
					}
				});

				this.$filter.on('change', 'input[data-type="checker"]', function (e) {
					_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.renderContent(response);
						_this2.preloader('hide');
					});
				});
			} else if (this.type === 'construction') {
				this.$filter.on('input', 'input[data-type="field"]', (0, _debounce2.default)(function () {
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.renderContent(response);
						_this2.preloader('hide');
					});
				}, 1000));

				this.$filter.on('change', 'input[data-type="checker"]', function (e) {
					_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.renderContent(response);
						_this2.preloader('hide');
					});
				});

				$('#filter-content').on('change', '[data-progress-button]', function () {
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.renderContent(response);
						_this2.preloader('hide');
					});
				});
			} else {
				this.$filter.on('change', 'input[data-type="checker"]', function (e) {
					_this.norerederfiel = e.target.closest('[data-name-filter]').getAttribute('data-name-filter');
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.render(response);
						_this2.updateSummary(response);
						_this2.preloader('hide');
					});
				});

				this.$filter.on('input', 'input[data-type="field"]', (0, _debounce2.default)(function () {
					_this2.preloader('show');
					_this2.request().then(function (response) {
						_this2.render(response);
						_this2.updateSummary(response);
						_this2.preloader('hide');
					});
				}, 1000));

				this.$form.on('submit', function (e) {
					e.preventDefault();

					if (_this2.link) {
						window.location.href = _this2.link;
					}
				});
			}
		}
	}, {
		key: 'renderContent',
		value: function renderContent(response) {
			var $roomInputs = this.$filter.find('[data-room]');
			var $houseInputs = this.$filter.find('[data-layout-filter-control="home"]');
			var $dateInputs = this.$filter.find('[data-layout-filter-control="date"]');

			if (response.activeDate) {
				var $dateSelect = $('#select_date');
				var activeOption = $dateInputs.filter('[value="' + response.activeDate + '"]');
				activeOption.prop('checked', true);
				var updateBox = $dateSelect.data('updateBox');
				updateBox($dateSelect);
			}

			var activeCheckboxes = {
				house: Object.values(response.isset_home_name)
			};

			if (response.isset_count_room) {
				$.extend(activeCheckboxes, {
					room: Object.values(response.isset_count_room)
				});
				this.sortCheckboxes($roomInputs, activeCheckboxes.room);
			}

			if (response.isset_dates) {
				$.extend(activeCheckboxes, {
					dates: Object.values(response.isset_dates)
				});
				this.sortCheckboxes($dateInputs, activeCheckboxes.dates);
			}

			this.sortCheckboxes($houseInputs, activeCheckboxes.house);

			if (!response.html.length) {
				console.error('Что-то пошло не так');
				return;
			}

			var $totalMetering = this.$filter.find('[data-layout-filter-control="totalMetering"]');
			var $kitchenMetering = this.$filter.find('[data-layout-filter-control="kitchenMetering"]');

			if ($totalMetering.length && $kitchenMetering.length) {
				var $totalInstance = $totalMetering.data('ionRangeSlider');
				var $kitchenInstance = $kitchenMetering.data('ionRangeSlider');
				this.$filter.find('[data-total-min]').text(response.min_area);
				this.$filter.find('[data-total-max]').text(response.max_area);
				this.$filter.find('[data-kitchen-min]').text(response.min_kitchen);
				this.$filter.find('[data-kitchen-max]').text(response.max_kitchen);

				$totalInstance.update({
					from: response.min_area,
					to: response.max_area
				});

				$kitchenInstance.update({
					from: response.min_kitchen,
					to: response.max_kitchen
				});
			}

			var $contentContainer = $('#filter-content');
			$contentContainer.html(response.html);
			var $jsInits = $contentContainer.find('.js-init');
			var $favoriteTriggers = $jsInits.filter('[data-favorites]');
			var $sliders = $jsInits.filter('[data-slider]');
			var $videos = $jsInits.filter('[data-video-preview]');

			if ($favoriteTriggers.length) {
				new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 99)).then(function (module) {
					module.default($favoriteTriggers);
				});
			}

			if ($contentContainer.find('.js-mfp-gallery').length) {
				new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 139)).then(function (module) {
					module.default();
				});
			}

			if ($contentContainer.find('.lozad').length) {
				new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 97)).then(function (module) {
					module.init($);
				});
			}
			if ($sliders.length) {
				new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 98)).then(function (module) {
					module.default($sliders.toArray());
				});
			}

			if ($videos.length) {
				new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 143)).then(function (_ref) {
					var videoPreview = _ref.videoPreview;

					videoPreview($videos);
				});
			}
		}
	}, {
		key: 'setRadio',
		value: function setRadio($inputs, values) {
			var _this3 = this;

			$inputs.each(function (i, el) {
				var $el = $(el);
				var value = $el.val();

				if (values.includes(value)) {
					_this3.setRadioActive($el);
				} else {
					_this3.setRadioInactive($el);
				}
			});
		}
	}, {
		key: 'setRadioActive',
		value: function setRadioActive($input) {
			var $label = $input.closest('label');
			$label.addClass('is-active');
		}
	}, {
		key: 'setRadioInactive',
		value: function setRadioInactive($input) {
			var $label = $input.closest('label');
			$label.removeClass('is-active');
		}
	}, {
		key: 'sortCheckboxes',
		value: function sortCheckboxes($inputs, values) {
			var _this4 = this;

			$inputs.each(function (i, el) {
				var $el = $(el);
				var $label = $el.closest('label');
				var value = $el.val();

				if ($el.is(':checked')) {
					$label.addClass('is-active');
				} else {
					$label.removeClass('is-active');
				}

				if (values.includes(value)) {
					_this4.setCheckboxActive($el);
				} else {
					_this4.blockCheckbox($el);
				}
			});
		}
	}, {
		key: 'blockCheckbox',
		value: function blockCheckbox($input) {
			var $label = $input.closest('label');
			$input.prop({ 'disabled': true, 'checked': false });
			$label.addClass('is-disabled');
		}
	}, {
		key: 'setCheckboxActive',
		value: function setCheckboxActive($input) {
			var $label = $input.closest('label');
			$input.prop('disabled', false);
			$label.removeClass('is-disabled');
		}
	}, {
		key: 'collectData',
		value: function collectData() {
			/* eslint-disable no-undef */
			var data = new FormData(this.$form.get(0));
			return data;
		}
	}, {
		key: 'request',
		value: function request() {
			var _self = this;
			return $.ajax({
				url: _self.route,
				type: 'POST',
				data: _self.collectData(),
				dataType: 'JSON',
				processData: false,
				contentType: false
			}).done(function (response) {}).fail(function (err) {
				console.warn(err);
				_self.preloader('hide');
			}).always(function (response) {});
		}
	}, {
		key: 'render',
		value: function render(response) {
			var _this5 = this;

			var $total = $('.js-zhk-current-number');
			var $nearmetro = $('[data-name-filter="nearmetro"]');
			var $installment = $('[data-name-filter="installment"]');
			var $credit = $('[data-name-filter="credit"]');
			var _this = this;

			if (response.currentCount) {
				$total.text(response.currentCount);
			}

			if (response.nearmetro) {
				$nearmetro.removeClass('is-disabled');
			} else {
				$nearmetro.addClass('is-disabled');
			}

			if (response.individual_credit) {
				$installment.removeClass('is-disabled');
			} else {
				$installment.addClass('is-disabled');
			}

			if (response.credit) {
				$credit.removeClass('is-disabled');
			} else {
				$credit.addClass('is-disabled');
			}
			Object.keys(response.filter).forEach(function (key) {
				if (/^price$/i.test(key)) {
					var $filterBlock = _this5.$allBoxes.filter('[data-name-filter="' + key + '"]');
					var price = response.filter[key];
					$filterBlock.find('[name="minprice"]').val(price.from);
					$filterBlock.find('[name="maxprice"]').val(price.to);
				} else if (/^metering$/i.test(key)) {
					var _$filterBlock = _this5.$allBoxes.filter('[data-name-filter="' + key + '"]');
					var metering = response.filter[key];

					_$filterBlock.find('[name="minarea"]').val(metering.from);
					_$filterBlock.find('[name="maxarea"]').val(metering.to);
				} else if (/^komnaty$/i.test(key) || /^year$/i.test(key)) {
					var _$filterBlock2 = _this5.$allBoxes.filter('[data-name-filter="' + key + '"]');
					var $checkboxes = _$filterBlock2.find('[name="' + key + '[]"]');
					var data = response.filter[key];
					$checkboxes.parent().removeClass('is-disabled');
					data.forEach(function (item) {
						if (item.disabled) {
							$checkboxes.filter('[value="' + item.value + '"]').parent().addClass('is-disabled');
						}
					});
				} else if (/^top_builders$/i.test(key)) {
					var _$filterBlock3 = _this5.$allBoxes.filter('[data-name-filter="builders"]');
					var _$checkboxes = _$filterBlock3.find('[data-multiselect-input]');
					var _data = response.filter[key];
					_$checkboxes.parent().removeClass('is-disabled');
					_data.forEach(function (item) {
						if (item.disabled) {
							_$checkboxes.filter('[value="' + item.value + '"]').parent().addClass('is-disabled');
						}
					});
				} else {
					if (key !== _this.norerederfiel) {
						var $box = _this5.$allBoxes.filter('[data-name-filter="' + key + '"]').find('[data-select-box]');
						var _data2 = response.filter[key];
						var $boxList = $box.find('.select-box__list');
						var newItems = [];

						if (_data2 && _data2.length) {
							var $boxItem = $box.find('.select-box__item').first().detach();
							$box.removeClass('is-disabled');

							_data2.forEach(function (item) {
								var $tplItem = $boxItem.clone(true, true);
								var $tplItemInput = $tplItem.find('.control__field');
								var $tplItemText = $tplItem.find('.control__text');
								var isCurrent = !!item.checked;
								var isDisabled = !!item.disabled;
								var isBold = !!item.bold;
								var filter = $('[data-filter="main"]');

								$tplItem.find('.control').removeClass('is-disabled');
								$tplItem.removeClass('is-disabled');
								filter.find('.is-bold').removeClass('is-bold');

								$tplItemInput.removeAttr('disabled').removeAttr('checked').prop('checked', false).prop('disabled', false);

								$tplItem.toggleClass('is-disabled', isDisabled);
								$tplItemInput.val(item.value).prop('checked', isCurrent).prop('disabled', isDisabled);

								if (isCurrent) {
									$tplItem.addClass('is-active');
								}

								if (isBold) {
									$tplItem.addClass('is-bold');
								}

								if ($box.hasClass('select-box--single') && !isDisabled) {
									$tplItem.toggleClass('is-disabled', isCurrent);
								}

								$tplItemText.text(item.name);
								newItems.push($tplItem);
							});

							$boxList.empty().append(newItems);
							$box.data('updateBox')($box, 'filter');
						} else {
							$box.addClass('is-disabled');
							$box.data('resetBox')($box, 'filter');
						}
					}
				}
			});
		}
	}, {
		key: 'preloader',
		value: function preloader() {
			var _this6 = this;

			var action = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (!action) {
				return;
			}

			var timeout = null;

			if (action === 'show') {
				this.$form.addClass('is-disabled');

				if (this.$preloader.length) {
					this.$preloader.addClass('is-shown');
				}
			} else if (action === 'hide') {
				window.clearTimeout(timeout);

				timeout = setTimeout(function () {
					_this6.$form.removeClass('is-disabled');

					if (_this6.$preloader.length) {
						_this6.$preloader.removeClass('is-shown');
					}
				}, 1000);
			}
		}
	}, {
		key: 'updateSummary',
		value: function updateSummary() {
			var oInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

			if (!oInfo) {
				return;
			}

			// this.$submit.addClass('has-result');
			if (oInfo.count) {
				this.$submit.prop('disabled', false).removeClass('is-disabled').find('[data-filter-results]').html(oInfo.btnText);
				this.$showAnotherView.removeClass('is-disabled');
			} else {
				this.$submit.prop('disabled', true).addClass('is-disabled').find('[data-filter-results]').html(oInfo.btnText);
				this.$showAnotherView.addClass('is-disabled');
			}
			this.$clearFilter.attr('href', oInfo.link['clear']);
			if (/catalog/i.test(this.locationPathName)) {
				this.link = oInfo.link['catalog'];
				this.$showAnotherView.attr('href', oInfo.link['maps']);
			} else if (/map/i.test(this.locationPathName)) {
				this.link = oInfo.link['maps'];
				this.$showAnotherView.attr('href', oInfo.link['catalog']);
			}
		}
	}]);

	return Filter;
}();

exports.default = Filter;

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.openPopup = openPopup;

var _cookieData = __webpack_require__(96);

var _cookieData2 = _interopRequireDefault(_cookieData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import 'magnific-popup';
function openPopup() {
	var $openPopup = $('[data-open-popup]');
	if (window.popUp) {
		var popUp = window.popUp;
		if (popUp['pop_up'] && popUp.showPopUp === false) {
			setTimeout(function () {
				var mfpInstance = $.magnificPopup ? $.magnificPopup.instance : false;
				if (mfpInstance) {
					if (!mfpInstance.isOpen) {
						$(document).on('galleryClosed', function () {
							deferOpen();
						});
						$(document).trigger('galleryClose');
					}
				} else {
					deferOpen();
				}
				if (!_cookieData2.default.receive('show_PopUp')) {
					_cookieData2.default.add('show_PopUp', true, { path: '/' });
				}
			}, popUp.time * 1000);
		}
	} else {
		$openPopup.on('click', function () {
			window.location.href = '#form';
		});
		var url = window.location.href.split('#');
		var param = url[url.length - 1].toString();

		if ($('#call_me').find($openPopup).length) {
			if (param === 'form') {
				$('#call_me').find($openPopup)[0].click();
			}
		}
	}

	function deferOpen() {
		$('#deferred-popup').find($openPopup)[0].click();
	}
}

/***/ }),

/***/ 394:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initShowMore = initShowMore;

var _jquery = __webpack_require__(51);

var _jquery2 = _interopRequireDefault(_jquery);

var _Preloader = __webpack_require__(43);

var _Preloader2 = _interopRequireDefault(_Preloader);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initShowMore($elements) {
	$elements.each(function (i, el) {
		var $el = (0, _jquery2.default)(el);
		showMore($el);
	});
}

function showMore($element) {
	var $container = $element.find('[data-container]');
	var $button = $element.find('[data-button]');

	var _$button$data = $button.data('button'),
	    count = _$button$data.count,
	    url = _$button$data.url,
	    alias = _$button$data.alias,
	    count_click = _$button$data.count_click; // eslint-disable-line camelcase


	var preloader = new _Preloader2.default($element);

	$button.on('click', function (e) {
		e.preventDefault();
		if (count && url) {
			_jquery2.default.ajax({
				type: 'GET',
				url: url,
				contentType: 'application/json',
				data: {
					count: count,
					alias: alias,
					count_click: count_click // eslint-disable-line camelcase
				},
				beforeSend: function beforeSend() {
					preloader.show();
					(0, _jquery2.default)('.old_btn_show').hide();
				}
			}).done(function (resp) {
				preloader.hide();
				if (resp) {
					$container.html(resp.html);
					if (resp.noMore) {
						$button.remove();
					}
				}
			});
		}
	});
}

/***/ }),

/***/ 395:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initMultiSelect = initMultiSelect;

var _MultiSelect = __webpack_require__(396);

var _MultiSelect2 = _interopRequireDefault(_MultiSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initMultiSelect($elements) {
	$elements.each(function (i, el) {
		var $el = $(el);
		if (!($el instanceof _MultiSelect2.default)) {
			var instance = new _MultiSelect2.default($el);
			instance.init();
		}
	});
}

/***/ }),

/***/ 396:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(51);

var _jquery2 = _interopRequireDefault(_jquery);

var _debounce = __webpack_require__(68);

var _debounce2 = _interopRequireDefault(_debounce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MultiSelect = function () {
	function MultiSelect($root) {
		var _this = this;

		_classCallCheck(this, MultiSelect);

		this.$root = $root;
		this.id = this.$root.data('multiselect');
		this.$paramsContainer = (0, _jquery2.default)('[data-multiselect-params="' + this.id + '"]');
		this.$search = (0, _jquery2.default)('[data-multiselect-search]');
		this.classes = {
			open: 'is-open'
		};
		this.$dropdown = this.$root.find('[data-multiselect-dropdown]');
		this.watchForClose = function (event) {
			var $target = (0, _jquery2.default)(event.target);
			if (_this.$root[0] !== $target.closest('[data-multiselect]')[0]) {
				_this.close();
			}
		};
		this.watchForClose.bind(this);
		this.$inputs = this.$root.find('[data-multiselect-input]');
		this.$holder = this.$root.find('[data-holder]');
		this.activeParams = [];
		this.$reset = this.$paramsContainer.find('[data-param-reset]');
		this.$dropdown = this.$root.find('[data-multiselect-dropdown]');
	}

	_createClass(MultiSelect, [{
		key: 'open',
		value: function open() {
			this.$root.addClass(this.classes.open);
			(0, _jquery2.default)(window).on('click', this.watchForClose);
		}
	}, {
		key: 'close',
		value: function close() {
			this.$root.removeClass(this.classes.open);
			(0, _jquery2.default)(window).off('click', this.watchForClose);
		}
	}, {
		key: 'onInputsChange',
		value: function onInputsChange(e) {
			var $this = (0, _jquery2.default)(e.currentTarget);
			if ($this.prop('checked') === true) {
				var name = $this.data('name');
				var value = $this.data('value');
				this.activeParams.push({ name: name, value: value });
				this.setHolderData(value);
			} else {
				var _name = $this.data('name');
				var _value = $this.data('value');
				this.activeParams = this.activeParams.filter(function (obj) {
					return obj.name !== _name;
				});
				var $param = this.params.filter(function (i, el) {
					return (0, _jquery2.default)(el).data('param') === _value;
				});
				this.removeParam(_value, $param);
			}
		}
	}, {
		key: 'attachHandlers',
		value: function attachHandlers() {
			var _this2 = this;

			this.$root.on('click', function () {
				_this2.open();
			});
			this.$inputs.on('change', function (e) {
				_this2.onInputsChange(e);
			});

			this.$reset.on('click', function () {
				_this2.resetSelect();
			});

			this.$paramsContainer.on('click', this.params, function (e) {
				var $this = (0, _jquery2.default)(e.target).closest('[data-param]');
				_this2.removeParam($this.data('param'), $this);
			});

			this.$search.on('input', (0, _debounce2.default)(function (e) {
				var $input = (0, _jquery2.default)(e.currentTarget);
				var url = $input.data('url');
				var query = $input.val();
				_jquery2.default.ajax({
					method: 'POST',
					url: url,
					data: {
						query: query
					}
				}).done(function (resp) {
					var $markup = (0, _jquery2.default)(resp.html);
					$markup.find('[data-multiselect-input]').each(function (i, el) {
						var $el = (0, _jquery2.default)(el);
						if (_this2.activeParams.find(function (obj) {
							return obj.name === $el.data('name');
						})) {
							$el.prop('checked', true);
						}
					});
					_this2.$dropdown.html($markup);
					_this2.$dropdown.find('[data-multiselect-input]').on('click', function (e) {
						_this2.onInputsChange(e);
					});
				}).fail(function () {
					console.warn('Ошибка загрузки данных');
				});
			}, 300));
		}
	}, {
		key: 'removeParam',
		value: function removeParam(param, $element) {
			var $targetInput = this.$inputs.filter(function (i, el) {
				return (0, _jquery2.default)(el).data('value') === param;
			});
			var holderVal = JSON.parse(this.$holder.val()).filter(function (val) {
				return val !== param;
			});
			this.activeParams = this.activeParams.filter(function (obj) {
				return obj.value !== param;
			});
			this.$holder.val(holderVal.length ? JSON.stringify(holderVal) : '');
			$targetInput.prop('checked', false);
			$element.remove();
			this.$holder.trigger('change');
		}
	}, {
		key: 'resetSelect',
		value: function resetSelect() {
			this.$inputs.prop('checked', false);
			this.clearParams();
			this.$holder.val('');
			this.activeParams = [];
			this.$holder.trigger('change');
		}
	}, {
		key: 'clearParams',
		value: function clearParams() {
			this.params.remove();
		}
	}, {
		key: 'attachParams',
		value: function attachParams() {
			var _this3 = this;

			this.clearParams();
			var params = this.activeParams.reduce(function (acc, obj) {
				return _this3.createParam(obj.name, obj.value) + acc;
			}, '');
			this.$paramsContainer.prepend(params);
		}
	}, {
		key: 'createParam',
		value: function createParam(name, value) {
			return '<div class="param" data-param="' + value + '">\n\t\t\t<span>' + name + '</span>\n\t\t\t<svg class="param__icon">\n\t\t\t\t<use xlink:href="/Media/assets/images/sprites/icons.svg#close"></use>\n\t\t\t</svg>\n\t\t</div>';
		}
	}, {
		key: 'setHolderData',
		value: function setHolderData(data) {
			var currentValue = this.$holder.val() ? JSON.parse(this.$holder.val()) : [];
			currentValue.push(data);
			this.$holder.val(JSON.stringify(currentValue));
			this.attachParams(currentValue);
			this.$holder.trigger('change');
		}
	}, {
		key: 'removeDataFromHolder',
		value: function removeDataFromHolder(data) {
			var currentValue = JSON.parse(this.$holder.val());
			var newVal = currentValue.filter(function (val) {
				return val !== data;
			});
			this.$holder.val(newVal.length ? JSON.stringify(newVal) : '');
		}
	}, {
		key: 'init',
		value: function init() {
			this.attachHandlers();
		}
	}, {
		key: 'params',
		get: function get() {
			return this.$paramsContainer.find('[data-param]');
		}
	}]);

	return MultiSelect;
}();

exports.default = MultiSelect;

/***/ }),

/***/ 397:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.initLayoutFilter = initLayoutFilter;

var _LayoutFilter = __webpack_require__(398);

function initLayoutFilter($elements) {
	$elements.each(function (i, el) {
		var $el = $(el);
		if ($el instanceof _LayoutFilter.LayoutFilter) {
			return true;
		}
		var instance = new _LayoutFilter.LayoutFilter($el);
		instance.init();
	});
}

/***/ }),

/***/ 398:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.LayoutFilter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(51);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LayoutFilter = exports.LayoutFilter = function () {
	function LayoutFilter($root) {
		var _this = this;

		_classCallCheck(this, LayoutFilter);

		this.$root = $root;
		this.$container = (0, _jquery2.default)('[data-layout-filter-container]');
		this.$items = this.$container.find('[data-layout-filter-item]');
		this.$controls = this.$root.find('[data-layout-filter-control]:not([data-tange-slider])');
		this.$rangeControls = this.$root.find('[data-layout-filter-control][data-range-slider]');
		this.classes = {
			hide: '_hide'
		};
		this.activeData = {};

		this.setActiveItems = function (event) {
			var $this = (0, _jquery2.default)(event.target);
			if (!$this.is('[data-range-slider]')) {
				if ($this.prop('checked')) {
					if (_this.activeData[$this.data('layout-filter-control')] && !$this.closest('[data-select-box]').length) {
						_this.activeData[$this.data('layout-filter-control')].data.push($this.val());
					} else {
						_this.activeData[$this.data('layout-filter-control')] = {
							type: 'default',
							data: [$this.val()]
						};
					}
				} else {
					_this.activeData[$this.data('layout-filter-control')] = {
						type: 'default',
						data: _this.activeData[$this.data('layout-filter-control')].data.filter(function (val) {
							return val !== $this.val();
						})
					};
				}
			} else {
				var data = event.target.value.split(';');
				_this.activeData[$this.data('layout-filter-control')] = {
					type: 'range',
					data: {
						from: Number(data[0]),
						to: Number(data[1])
					}
				};
			}
			var selector = $this.data('layout-filter-control');
			_this.filterItems(selector);
		};

		this.setActiveItems.bind(this);
	}

	_createClass(LayoutFilter, [{
		key: 'filterItems',
		value: function filterItems(selector) {
			var _this2 = this;

			this.$items.filter(function (i, el) {
				var $el = (0, _jquery2.default)(el);
				var config = $el.data('layout-filter-item');
				var disabledBy = $el.data('disabled-by') ? JSON.parse($el.data('disabled-by')) : [];
				if (_this2.activeData[selector].type === 'range') {
					if (config[selector] >= _this2.activeData[selector].data.from && config[selector] <= _this2.activeData[selector].data.to) {
						if (disabledBy.includes(selector)) {
							_this2.showElement($el, disabledBy, selector);
						}
					} else {
						if (!disabledBy.includes(selector)) {
							_this2.hideElement($el, disabledBy, selector);
						}
					}
				} else {
					if (_this2.activeData[selector].data.includes(config[selector]) || !_this2.activeData[selector].data.length) {
						if (disabledBy.includes(selector)) {
							_this2.showElement($el, disabledBy, selector);
						}
					} else {
						if (!disabledBy.includes(selector)) {
							_this2.hideElement($el, disabledBy, selector);
						}
					}
				}
			});
		}
	}, {
		key: 'hideElement',
		value: function hideElement($element, disabledData, selector) {
			if (!disabledData.includes(selector)) {
				disabledData.push(selector);
				$element.attr('data-disabled-by', JSON.stringify(disabledData));
				$element.data('disabled-by', JSON.stringify(disabledData));
				$element.addClass(this.classes.hide);
			}
		}
	}, {
		key: 'showElement',
		value: function showElement($element, disabledData, selector) {
			if (disabledData.includes(selector)) {
				if (disabledData.length) {
					disabledData = disabledData.filter(function (el) {
						return el !== selector;
					});
				}
				$element.attr('data-disabled-by', JSON.stringify(disabledData));
				$element.data('disabled-by', JSON.stringify(disabledData));
				if (!disabledData.length) {
					$element.removeClass(this.classes.hide);
				}
			}
		}
	}, {
		key: 'init',
		value: function init() {
			this.$controls.on('change', this.setActiveItems);
			this.$rangeControls.on('change', this.setActiveItems);
		}
	}]);

	return LayoutFilter;
}();

/***/ }),

/***/ 399:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.currencyChanger = currencyChanger;
function currencyChanger($elements) {
	$elements.each(function (i, el) {
		var $element = $(el);
		var url = $element.data('currency-changer');
		$element.on('click', '[data-currency-control]', function (event) {
			var $this = $(this).has(event.target) ? $(this) : $(event.target);
			if (!$this.hasClass('is-active')) {
				$('[data-currency-control]').removeClass('is-active');
				$this.addClass('is-active');
				var currency = $this.data('currency-control');
				$('[data-currency]').not('.dropdown__item').addClass('_hide');
				$('[data-currency="' + currency + '"]').not('.dropdown__item').removeClass('_hide');
				$.ajax({
					url: url,
					type: 'post',
					data: {
						currency: currency
					}
				});
			}
		});
	});
}

/***/ }),

/***/ 400:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.popupSliderClose = popupSliderClose;
function popupSliderClose() {
	$('[data-popup-slider]').on('click', function (e) {
		if ($(e.target).is('.popup-slider__item') || $(e.target).parent().is('.popup-slider__item') || $(e.target).is('.slider__arrow') || $(e.target).parent().is('.slider__arrow')) {
			return;
		}
		$.magnificPopup.close();
	});
}

/***/ }),

/***/ 401:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.iframeLazyload = iframeLazyload;

__webpack_require__(402);

function iframeLazyload($elements) {
	$elements.each(function (i, el) {
		var $el = $(el);

		$el.isInViewport(function (status) {
			if (status === 'entered') {
				$(this).prop('src', $el.data('src'));
			}
		});
	});
}

/***/ }),

/***/ 403:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.controlPanel = controlPanel;
function controlPanel($elements) {
	$elements.each(function (i, el) {
		var $el = $(el);
		var $controlPanel = $('[data-control-panel]');
		var $elHeight = $el.outerHeight();

		$(window).on('load scroll', function () {
			var offset = $el.offset();
			if ($(window).scrollTop() > offset.top + $elHeight) {
				$controlPanel.addClass('is-visible');
			} else {
				$controlPanel.removeClass('is-visible');
			}
		});
	});
}

/***/ }),

/***/ 404:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Вывод "Wezom" баннера в консоли браузера
 * @module
 */

(function (window) {
	var userAgent = window.navigator.userAgent.toLowerCase();
	var staticText = 'Агенство системных интернет-решений';
	var staticUrl = '> http://wezom.com.ua/';
	var staticLine = '----------------------------';

	var isWebkit = function (ua) {
		var webkit = 'WebkitAppearance' in document.body.style;
		var notEdge = !(ua.indexOf(' edge/') > 0);

		return webkit && notEdge;
	}(userAgent);

	var isIeOrEdge = function (ua) {
		var ie = /*@cc_on!@*/false || document.documentMode; // eslint-disable-line
		var edge = ua.indexOf(' edge/') > 0;

		return ie || edge;
	}(userAgent);

	if (isIeOrEdge) {
		window.console.info(staticText);
		window.console.info(staticUrl);
		window.console.log(staticLine);
	} else if (isWebkit) {
		var title = '%c';

		for (var i = 0; i < 12; i++) {
			title += ' ';
		}

		window.console.info(staticUrl);
		window.console.log(title, 'font: 75px/100% sans-serif; background: no-repeat url(data:image/jpeg;base64,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); background-size: 100%');
	} else {
		var _window$console;

		var _title = 'WEZOM';
		var banner = '\n%c' + _title.split('').join('%c %c') + '%c\n';
		var styler = [];

		var symbol = ['font:32px/1.5 Helvetica,Arial,sans-serif', 'color:#fff', 'background-color:#bb1919', 'padding:4px 14px'].join(';');

		_title.split('').forEach(function (arg) {
			styler.push(symbol);
			styler.push('');
		});

		(_window$console = window.console).log.apply(_window$console, [banner].concat(styler));
		window.console.log(staticText);
		window.console.log(staticUrl);
		window.console.log(staticLine);
	}
})(window);

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Простой прелоадер
 * @module
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _createTimer = __webpack_require__(359);

var _createTimer2 = _interopRequireDefault(_createTimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Дофелтный конфиг для всех экземпляров прелоадера
 * @type {Object}
 * @prop {string} mainClass - основной CSS класс, который добавляется к контейнеру прелодара
 * @prop {string} subClass - Дополнительный CSS класс - который будет добавлен, если имеет логически позитивное значение
 * @prop {string} showClass - CSS класс, который добавляется к контейнеру прелодара, при его показе
 * @prop {string} hideClass - CSS класс, который добавляется к контейнеру прелодара, перед его закрытием
 * @prop {number} removeDelay - время задержки, после которой будут удалены разметка прелоадре и CSS классы у контейнера
 * @prop {string} markup - Разметка прелодера
 * @private
 */
var defaultConfig = {
	mainClass: 'preloader',
	subClass: '',
	showClass: 'preloader--show',
	hideClass: 'preloader--hide',
	removeDelay: 300,
	markup: '<div class="preloader__block"></div>'
};

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Создание прелодаров
 * @param {JQuery} $container - контейнер для прелоадера
 * @param {Object} [userConfig={}] - Пользвательский конфиг для создваемого экземпляра
 * @prop {JQuery} [$container] - контейнер для прелоадера
 * @prop {Object} [config] - прелоадера
 * @prop {Object|number} timer - id таймера
 * @prop {boolean} empty
 * @example
 * let preloader = new Preloader($myElement);
 * preloader.show();
 * window.setTimeout(() => preloader.hide(), 1000);
 */

var Preloader = function () {
	function Preloader($container) {
		var userConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

		_classCallCheck(this, Preloader);

		if (!($container && $container.length)) {
			this.empty = true;
			return this;
		}
		if ($container.data('preloader') instanceof Preloader) {
			$container.data('preloader', null);
		}
		this.empty = false;
		this.$container = $container;
		this.config = $.extend(true, {}, Preloader.config, userConfig);
		this.timer = (0, _createTimer2.default)();
		this.$container.data('preloader', this);
	}

	/**
  * Показ прелодера
  * @param {string} [place="append"] - append / prepend / before / after
  * @sourceCode
  */


	_createClass(Preloader, [{
		key: 'show',
		value: function show() {
			var place = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'append';

			if (this.empty) {
				console.warn('Empty preloader cannot be shown!');
				return false;
			}
			var _config = this.config,
			    mainClass = _config.mainClass,
			    subClass = _config.subClass,
			    showClass = _config.showClass,
			    markup = _config.markup;


			this.$container.each(function (i, el) {
				var $container = $(el);
				$container.addClass(mainClass);
				if (subClass) {
					$container.addClass(subClass);
				}
				$container.data('$preloaderMarkup', $(markup));
				$container[place]($container.data('$preloaderMarkup'));
				window.setTimeout(function () {
					return $container.addClass(showClass);
				}, 10);
			});
		}

		/**
   * Скрытие прелодера
   * @param {boolean} [removeMarkup=true] - удалить разметку прелодера после скрытия
   * @sourceCode
   */

	}, {
		key: 'hide',
		value: function hide() {
			var _this = this;

			var removeMarkup = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

			if (this.empty) {
				console.warn('Empty preloader cannot be hidden!');
				return false;
			}
			var _config2 = this.config,
			    mainClass = _config2.mainClass,
			    subClass = _config2.subClass,
			    showClass = _config2.showClass,
			    hideClass = _config2.hideClass;

			this.$container.addClass(hideClass);

			this.timer(function () {
				if (removeMarkup) {
					_this.$container.each(function (i, el) {
						$(el).data('$preloaderMarkup').remove();
					});
				}
				_this.$container.removeClass([mainClass, showClass, hideClass]);
				if (subClass) {
					_this.$container.removeClass(subClass);
				}
			}, this.config.removeDelay);
		}

		/**
   * Получение глобального конфига для всех прелодаров
   * @returns {Object}
   * @sourceCode
   */

	}], [{
		key: 'config',
		get: function get() {
			return defaultConfig;
		}

		/**
   * Установка глобального конфига
   * @param {Object} value
   * @sourceCode
   * @example
   * Preloader.config = {mainClass: 'my-preloader'}
   */
		,
		set: function set(value) {
			$.extend(true, defaultConfig, value);
		}
	}]);

	return Preloader;
}();

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = Preloader;

/***/ }),

/***/ 96:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Модуль для работы с куки
 * @module
 */

// ----------------------------------------
// Private
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
var _window = window,
    encoder = _window.encodeURIComponent,
    decoder = _window.decodeURIComponent;

// ----------------------------------------
// Public
// ----------------------------------------

/**
 * Работа с `document.cookie`
 * @namespace cookieData
 */

var cookieData = {
	/**
  * Добавление записи
  * @param {string} key
  * @param {*} value
  * @param {Object} [options={}]
  * @param {Date|number|string} [options.expires]
  * @param {string} [options.path]
  * @param {string} [options.domain]
  * @param {boolean} [options.secure]
  * @see {@link https://learn.javascript.ru/cookie#функция-setcookie-name-value-options}
  * @sourceCode
  */
	add: function add(key, value) {
		var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

		if (!this.allowUsage && key !== this.allowUsageKey) {
			console.warn('Cookie usage is disallowed!');
			return false;
		}
		var expires = options.expires;

		if (typeof expires === 'number' && expires) {
			var d = new Date();
			d.setTime(d.getTime() + expires * 1000);
			expires = options.expires = d;
		}

		if (expires && expires.toUTCString) {
			options.expires = expires.toUTCString();
		}

		value = encoder(value);
		var updatedCookie = key + '=' + value;

		for (var propName in options) {
			updatedCookie += '; ' + propName;
			var propValue = options[propName];
			if (propValue !== true) {
				updatedCookie += '=' + propValue;
			}
		}

		document.cookie = updatedCookie;
	},


	/**
  * Получение куки по ключу
  * @param key
  * @return {string|undefined}
  * @see {@link https://learn.javascript.ru/cookie#функция-getcookie-name}
  * @sourceCode
  */
	receive: function receive(key) {
		var matches = document.cookie.match(new RegExp('(?:^|; )' + key.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)' // eslint-disable-line no-useless-escape
		));
		return matches ? decoder(matches[1]) : undefined;
	},


	/**
  * Удаление куки по ключу
  * @param {string} key
  * @see {@link https://learn.javascript.ru/cookie#функция-deletecookie-name}
  * @sourceCode
  */
	delete: function _delete(key) {
		this.add(key, '', { expires: -1 });
	},


	/**
  * Задать вопрос о пользовательском согласии использавния куки
  * @return {boolean}
  * @sourceCode
  */
	askUsage: function askUsage() {
		var _this = this;

		if (this.allowUsage) {
			return false;
		}

		this.$infoBlock = this.$infoBlock || $('[data-cookie-info]');
		this.$infoButton = this.$infoButton || $('[data-cookie-submit]');

		if (this.$infoBlock.length && this.$infoButton.length) {
			var hiddenClass = 'is-hidden';
			this.$infoButton.on('click', function () {
				_this.$infoBlock.addClass(hiddenClass);
				_this.add(_this.allowUsageKey, _this.allowUsageValue, {
					path: '/',
					expires: 365 * 24 * 60 * 60
				});
			});

			window.setTimeout(function () {
				_this.$infoBlock.removeClass(hiddenClass);
			}, this.allowUsageDelay);
			return true;
		}
	},


	/**
  * Проверка пользовательского согласия
  * на использования файлов cookie
  * @return {boolean}
  * @protected
  * @sourceCode
  */
	get allowUsage() {
		return this.receive(this.allowUsageKey) === this.allowUsageValue;
	},

	/**
  * Ключ проверки пользовательского согласия
  * на использования файлов cookie
  * @type {string}
  * @default 'allow-cookie-usage'
  * @protected
  * @sourceCode
  */
	get allowUsageKey() {
		return 'allow-cookie-usage';
	},

	/**
  * Значение ключа проверки пользовательского согласия
  * на использования файлов cookie
  * @type {string}
  * @default 'true'
  * @protected
  * @sourceCode
  */
	get allowUsageValue() {
		return 'true';
	},

	/**
  * Задержка (ms) для проверки пользовательского согласия
  * на использования файлов cookie
  * @type {number}
  * @default 2000
  * @protected
  * @sourceCode
  */
	get allowUsageDelay() {
		return 2000;
	}
};

// ----------------------------------------
// Exports
// ----------------------------------------

exports.default = cookieData;

/***/ }),

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Инит плгина lozad.js
 * @module
 * @see {@link https://github.com/ApoorvSaxena/lozad.js}
 */

// ----------------------------------------
// Imports
// ----------------------------------------

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.init = undefined;

__webpack_require__(357);

// ----------------------------------------
// Private
// ----------------------------------------

/**
 * Коллбек вставки источника
 * @param {JQuery} $el
 * @private
 * @sourceCode
 */
function onLoad($el) {
	var $parent = $el.parent('.lozad-parent');
	var delay = $el.data('lozad-delay') || 50;
	setTimeout(function () {
		if ($parent.length) {
			$parent.addClass('lozad-parent--is-ready');
		}
		$el.addClass('lozad--is-ready');
	}, delay);
}

/**
 * Добавлеям `lazyLoad` к глобальныму объекту `window`
 * @private
 * @sourceCode
 */
function createLazyLoad() {
	var lozad = __webpack_require__(358);
	window.lazyLoad = lozad('.lozad', {
		rootMargin: '100px 0px',
		load: function load(el) {
			var $el = $(el);
			var nodeName = $el.nodeName();
			var img = document.createElement('img');

			if (nodeName === 'picture') {
				var $img = $(img);
				$img.on('load', function () {
					return onLoad($el);
				});
				$el.append($img);
			} else {
				var src = $el.data('lozad');
				img.onload = function () {
					if ($el.nodeName() === 'img') {
						$el.attr('src', src);
					} else {
						$el.css('background-image', 'url(' + src + ')');
					}
					onLoad($el);
				};
				img.src = src;
			}
		}
	});

	window.lazyLoad.observe();
}

// ----------------------------------------
// Public
// ----------------------------------------

var init = exports.init = function init($) {
	if (!$('.lozad').length) {
		return false;
	}
	// Если в слайдере только 1 изображение, то некоректно отрабатывает
	var fixSlider = $('[data-slider] .slider__item:first-child:last-child .lozad');
	fixSlider.each(function (index, element) {
		var $el = $(element);
		var src = $el.data('lozad');
		if ($el.nodeName() === 'img') {
			$el.attr('src', src);
		} else {
			$el.css('background-image', 'url(' + src + ')');
		}
		$el.removeClass('lozad').removeAttr('data-lozad');
	});

	// если уже `lazyLoad` добавлен вызываем
	if (window.lazyLoad) {
		return window.lazyLoad.observe();
	}

	// иначе добавляем
	if (window.Modernizr.intersectionobserver) {
		createLazyLoad();
	} else {
		// грузим асинхронно полифилл если не поддерживается Intersection Observer
		__webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 405)).then(createLazyLoad);
	}
};

init($);

// export default init;

/***/ }),

/***/ 98:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

exports.default = function () {
	var sliders = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

	window.sliderInstance = {};
	var config = window.projectConfig;
	var presetsList = config.plugin.slider.preset;

	var _loop2 = function _loop2(root) {
		var sliderStage = root.querySelector('[data-slider="stage"]');
		var sliderItems = sliderStage.children.length;

		if (!sliderItems) {
			return 'continue';
		}

		var preset = root.dataset.slider.toLocaleLowerCase() || {};
		var currentPreset = presetsList[preset];

		/**
   * Когда слайдов меньше, чем кол-во слайдов указанное в perPage, слайдер валится
   * Поэтому лишние значения в объекте (если это объект) срезаем
   */
		var perPageIsObject = currentPreset.perPage instanceof Object;

		if (perPageIsObject) {
			Object.keys(currentPreset.perPage).forEach(function (key, index) {
				if (sliderItems < index + 1) {
					delete currentPreset.perPage[key];
				}
			});
		}

		var instance = new _siema2.default(Object.assign({}, {
			// Default preset
			selector: sliderStage,
			duration: 200,
			easing: 'ease-out',
			perPage: 1,
			startIndex: 0,
			draggable: true,
			multipleDrag: true,
			threshold: 30,
			keyboardNav: true,
			dots: false, // custom option
			arrows: true, // custom option
			arrowPrev: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			arrowNext: null, // custom option [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			loop: true,
			rewind: false, // custom option - if rewind `true`, loop needs to be `false` - [DO NOT USE IT FOR NOW. NEED TO IMPLEMENT LOGIC]
			autoplay: false, // custom option
			autoplayInterval: 3000, // custom option
			stopOnHover: true, // custom option
			rtl: false,
			onInit: function onInit() {},
			onChange: function onChange() {
				this.updateActive();
			}
		}, currentPreset));
		instance.root = root;
		instance.generateDots();
		instance.generateArrows();
		instance.setActive();
		instance.autoplay();
		instance.keyboardNav();
		// instance.rewind();
		root.classList.add('is-initialized');
		instance.inited = true;
		// window.sliderInstance[preset] = instance;
		// window.sliderInstance['building_view_gallery'].resizeHandler()

		window.addEventListener('resize', function () {
			root.classList.toggle('hide-controls', sliderItems <= instance.perPage);
		});
		$(document).on('currentSlideUpdated', function () {
			if (instance.root.dataset.slider === 'gallery') {
				instance.goTo(window.popupSlide);
			}
		});
	};

	var _iteratorNormalCompletion = true;
	var _didIteratorError = false;
	var _iteratorError = undefined;

	try {
		for (var _iterator = sliders[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
			var root = _step.value;

			var _ret2 = _loop2(root);

			if (_ret2 === 'continue') continue;
		}
	} catch (err) {
		_didIteratorError = true;
		_iteratorError = err;
	} finally {
		try {
			if (!_iteratorNormalCompletion && _iterator.return) {
				_iterator.return();
			}
		} finally {
			if (_didIteratorError) {
				throw _iteratorError;
			}
		}
	}

	$(document).on('popupSliderUpdate', function () {
		triggerEvent(window, 'resize');
	});

	triggerEvent(window, 'resize');
};

var _siema = __webpack_require__(370);

var _siema2 = _interopRequireDefault(_siema);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// @TODO => Написать два метода которые буду возвращать два флага: последний ли это слайд и первые ли это слайд
// Или по другому, есть ли еще слады для листания вперед или назад или нет

_siema2.default.prototype.generateDots = function () {
	var _this = this;

	if (!this.config.dots) {
		return;
	}

	var dotsContainer = this.root.querySelector('[data-slider="dots"]');
	var slides = this.innerElements;
	this.dots = [];

	var _loop = function _loop(i) {
		var button = document.createElement('button');

		button.textContent = i;
		button.setAttribute('type', 'button');
		button.setAttribute('title', i + 1 + '/' + slides.length);
		button.className = 'slider__dot';
		button.addEventListener('click', function () {
			return _this.goTo(i);
		});
		dotsContainer.appendChild(button);
		_this.dots.push(button);
	};

	for (var i = 0; i < slides.length; i++) {
		_loop(i);
	}

	this.root.classList.add('has-dots');
};

_siema2.default.prototype.generateArrows = function () {
	var _this2 = this;

	if (!this.config.arrows) {
		return;
	}

	var arrowsContainer = this.root.querySelector('[data-slider="arrows"]');
	var arrows = ['prev', 'next'];
	var title = {
		prev: arrowsContainer.dataset.prev || 'Previous slide',
		next: arrowsContainer.dataset.next || 'Next slide'
	};
	var innerMarkup = {
		prev: '<i class="svgi svgi--chevron-left"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20"><path d="M10.873,17.982 L9.600,19.256 L0.001,9.655 L0.037,9.619 L0.001,9.583 L9.600,-0.017 L10.873,1.256 L2.510,9.619 L10.873,17.982 Z"/></svg></i>',
		next: '<i class="svgi svgi--chevron-right"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 20"><path d="M10.873,9.655 L1.273,19.256 L0.001,17.982 L8.364,9.619 L0.001,1.256 L1.273,-0.017 L10.873,9.583 L10.837,9.619 L10.873,9.655 Z"/></svg></i>'
	};

	arrows.forEach(function (arrow) {
		var button = document.createElement('button');
		// button.textContent = arrow;
		button.setAttribute('type', 'button');
		button.setAttribute('title', title[arrow]);
		button.className = 'slider__arrow slider__arrow--' + arrow;
		button.innerHTML = innerMarkup[arrow];
		button.addEventListener('click', function () {
			_this2[arrow]();
			// this.rewind();  // @TODO => NEEDS TO IMPLEMENT CORRECT LOGIC FOR REWIND OPTION
		});
		arrowsContainer.appendChild(button);
	});

	this.root.classList.add('has-arrows');
};

_siema2.default.prototype.autoplay = function () {
	var _this3 = this;

	if (!this.config.autoplay) {
		return;
	}

	var interval = null;
	var interavalFn = function interavalFn() {
		clearInterval(interval);

		interval = setInterval(function () {
			_this3.next();
		}, _this3.config.autoplayInterval || 3000);
	};

	interavalFn();

	if (this.config.stopOnHover) {
		this.selector.addEventListener('mouseover', function () {
			clearInterval(interval);
		});
		this.selector.addEventListener('mouseout', interavalFn);
	}
};

_siema2.default.prototype.keyboardNav = function () {
	var _this4 = this;

	if (!this.config.keyboardNav) {
		return;
	}

	var action = function action(e) {
		if (e.keyCode === 37) {
			// if it's left arrow key
			_this4.prev();
		} else if (e.keyCode === 39) {
			// if it's right arrow key
			_this4.next();
		}
	};
	this.selector.addEventListener('mouseover', function () {
		var _this5 = this;

		document.onkeydown = function (e) {
			action.call(_this5, e);
		};
	});
	this.selector.addEventListener('mouseout', function () {
		document.onkeydown = function () {};
	});
};

_siema2.default.prototype.rewind = function () {
	var _config = this.config,
	    loop = _config.loop,
	    rewind = _config.rewind;

	if (!rewind) {
		return;
	}
	if (loop && rewind) {
		return;
	}
	// console.log(this.currentSlide, this.innerElements.length);
	if (this.currentSlide === this.innerElements.length - 1) {
		this.goTo(0);
	}
	if (this.currentSlide === 0) {
		this.goTo(this.innerElements.length - 1);
	}
};

_siema2.default.prototype.setActive = function () {
	var slides = this.innerElements;
	for (var i = 0; i < slides.length; i++) {
		var slide = slides[i];
		slide.setAttribute('data-slide', i);
	}

	if (this.config.dots) {
		var dots = this.dots;
		for (var _i = 0; _i < dots.length; _i++) {
			var dot = dots[_i];
			dot.setAttribute('data-slide', _i);
		}
	}

	this.updateActive();
};

_siema2.default.prototype.updateActive = function () {
	if (this.inited) {
		var allLozad = this.selector.querySelectorAll('[data-slide="' + this.currentSlide + '"], [data-slide="' + (this.currentSlide < this.innerElements.length ? this.currentSlide + 1 : 0) + '"]');
		for (var i = 0; i < allLozad.length; i++) {
			var element = allLozad[i].getElementsByClassName('lozad');
			if (element.length) window.lazyLoad.triggerLoad(element[0]);
		}
	}

	var slides = this.innerElements;
	for (var _i2 = 0; _i2 < slides.length; _i2++) {
		var slide = slides[_i2];
		slide.classList.toggle('is-active', +slide.dataset.slide === this.currentSlide);
	}

	if (this.config.dots) {
		var dots = this.dots;
		for (var _i3 = 0; _i3 < dots.length; _i3++) {
			var dot = dots[_i3];
			dot.classList.toggle('is-active', +dot.dataset.slide === this.currentSlide);
		}
	}
};

_siema2.default.prototype.printSlideIndexWithIndicator = function () {
	var currentSlide = this.currentSlide;
	var currentSelector = $(this.selector).find('[data-current]');
	var totalSelector = $(this.selector).find('[data-total]');
	if (currentSlide < 0) {
		currentSelector.html(this.innerElements.length + currentSlide + 1);
	} else {
		currentSelector.html(this.currentSlide + 1);
	}
	totalSelector.html(this.innerElements.length);
};

var triggerEvent = function triggerEvent(element, event) {
	var e = document.createEvent('HTMLEvents');
	e.initEvent(event, false, true);
	element.dispatchEvent(e);
};

/**
 * На вход передаем выборку (массив) чистых DOM елементов и инициализируем слайдеры
 * @param {Array} [sliders=[]] - массив слайдеров
 */

/***/ }),

/***/ 99:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = initFavorites;

var _Favorites = __webpack_require__(389);

var _Favorites2 = _interopRequireDefault(_Favorites);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initFavorites($allTriggers) {
	$allTriggers.each(function (i, trigger) {
		var $trigger = $(trigger);
		/* eslint-disable no-unused-vars */
		var favorite = new _Favorites2.default($trigger, $allTriggers);
	});
}

/***/ })

},[145]);


// WEBPACK FOOTER //
// initialize.js